// AUTO-GENERATED by scripts/build-instruction-catalog.mjs
// Source: @sly-rentals/core TypeDoc JSON output.
// Do not edit by hand; rebuild via "pnpm run build:catalog".

export type ParamTypeKind =
  | 'signer'
  | 'address'
  | 'amount'
  | 'duration'
  | 'schedule'
  | 'number'
  | 'boolean'
  | 'string'
  | 'unknown';

export type InstructionGroup =
  | 'config'
  | 'borrower'
  | 'contract'
  | 'rental'
  | 'affiliate'
  | 'reservation'
  | 'discount'
  | 'member'
  | 'vault'
  | 'other';

export interface InstructionParam {
  name: string;
  type: string;
  typeKind: ParamTypeKind;
  description: string;
  optional: boolean;
  examples: string[];
  defaultValue?: string;
}

export interface ResultAccount {
  /**
   * Position in the target TransactionInstruction's keys array — the
   * account whose post-tx state the playground offers to fetch.
   * The fetch type is derived at runtime from the sidebar grouping
   * (group + subgroup) rather than baked into the catalog so adding a
   * new subgroup only needs an entry in instruction-display.ts.
   */
  accountIndex: number;
  /**
   * Total accounts on the target instruction per the Anchor IDL.
   * Some wrappers bundle multiple instructions (e.g. createContract
   * bundles createContractThread when automated is true), so the
   * runner uses this to pick the right ix before indexing.
   */
  keysCount: number;
}

export interface Instruction {
  name: string;
  paramsType: string;
  group: InstructionGroup;
  isAdmin: boolean;
  description: string;
  params: InstructionParam[];
  /**
   * Account to auto-fetch after a successful submission, if any. Closes
   * and deletes still set this so the user sees the post-tx "notfound"
   * confirmation; pure side-effect instructions (release/invalidate) omit it.
   */
  resultAccount?: ResultAccount;
  /**
   * Groups of param names where exactly one must be provided. The SDK
   * enforces this at runtime; the UI surfaces it as a "one of" tag and
   * keeps the params in the main schema instead of hiding them under
   * Advanced.
   */
  requiresOneOf?: string[][];
}

export interface SchemaField {
  /** Camel-case field name as it appears on the decoded JS object. */
  name: string;
  /** Short display string — primitive (`u64`), `pubkey`, `option<pubkey>`, enum name, etc. */
  type: string;
  /** Field doc comment from the IDL, joined into a single line. */
  docs: string;
}

export interface FetchEntry {
  name: string;
  /** Underlying decoded account type ("contract", "rental", ...). */
  acct: string;
  /** Sidebar group this fetch lives under (often === acct, sometimes overridden). */
  group: InstructionGroup;
  description: string;
  /** Field shape of the decoded `data` payload. Only present for SRSLY-program accounts. */
  schema?: SchemaField[];
}

export interface EventEntry {
  /** Anchor IDL name — used as the runtime event-type discriminator. */
  name: string;
  /** Top-level dot-path group from the SDK's events tree (`events.{group}`). */
  group: string;
  /** Verb under the group (`events.{group}.{verb}`). */
  verb: string;
  /** Multi-paragraph IDL doc comment. */
  description: string;
  /** Decoded payload shape — fields the user gets on their handler arg. */
  schema: SchemaField[];
}

export interface Query {
  /** SDK export name (e.g. `getContractSnapshot`). */
  name: string;
  /** First-paragraph JSDoc summary. */
  description: string;
  /** Unwrapped return type rendered as a string (e.g. `ContractSnapshot`, `RentalCostQuote`). */
  returnType: string;
  /** Sidebar group this query slots into — same buckets as instructions. */
  group: InstructionGroup;
  /** Param schema. Empty for nullary helpers like `tickBudget`. */
  params: InstructionParam[];
}

export const INSTRUCTIONS: Instruction[] = [
  {
    "name": "approveAffiliate",
    "paramsType": "ApproveAffiliateParams",
    "group": "affiliate",
    "isAdmin": true,
    "description": "Activate a pending affiliate so they start earning a slice of the parent member's allocation (not of the total vault).",
    "params": [
      {
        "name": "authority",
        "type": "UniversalSigner",
        "typeKind": "signer",
        "description": "Parent member authority who approves the affiliate Accepts string address, web3.js Keypair, or @solana/kit signer",
        "optional": false,
        "examples": []
      },
      {
        "name": "vault",
        "type": "string | Address",
        "typeKind": "address",
        "description": "Vault address",
        "optional": false,
        "examples": []
      },
      {
        "name": "memberState",
        "type": "string | Address",
        "typeKind": "address",
        "description": "Parent member state address",
        "optional": false,
        "examples": []
      },
      {
        "name": "affiliateState",
        "type": "string | Address",
        "typeKind": "address",
        "description": "Affiliate state address to approve",
        "optional": false,
        "examples": []
      },
      {
        "name": "percentage",
        "type": "number",
        "typeKind": "number",
        "description": "Affiliate percentage (0-100) This is the percentage of the parent member's allocation",
        "optional": false,
        "examples": []
      },
      {
        "name": "computeUnits",
        "type": "number",
        "typeKind": "number",
        "description": "Sets compute units to allocate for the transaction.",
        "optional": true,
        "examples": []
      }
    ]
  },
  {
    "name": "claim",
    "paramsType": "ClaimParams",
    "group": "affiliate",
    "isAdmin": false,
    "description": "Withdraw a member's accumulated vault balance to their wallet. Member-callable any time; automatable via an Antegen thread.",
    "params": [
      {
        "name": "payer",
        "type": "UniversalSigner",
        "typeKind": "signer",
        "description": "Payer for account initialization (the signer) For manual claims: this should be the authority For automated claims: this is the thread Accepts string address, web3.js Keypair, or @solana/kit signer",
        "optional": false,
        "examples": []
      },
      {
        "name": "mint",
        "type": "string | Address",
        "typeKind": "address",
        "description": "Token mint address (required for explicit mode, auto-fetched otherwise)",
        "optional": true,
        "examples": []
      },
      {
        "name": "vault",
        "type": "string | Address",
        "typeKind": "address",
        "description": "Vault address (required for explicit mode, auto-fetched otherwise)",
        "optional": true,
        "examples": []
      },
      {
        "name": "authority",
        "type": "string | Address",
        "typeKind": "address",
        "description": "Member authority address (validated by member_state.authority) For manual claims: same as payer For automated claims: the member who will receive funds If omitted in auto-fetch mode, derived from payer",
        "optional": true,
        "examples": []
      },
      {
        "name": "memberState",
        "type": "string | Address",
        "typeKind": "address",
        "description": "Member state address to claim from (required for explicit mode, auto-fetched otherwise)",
        "optional": true,
        "examples": []
      },
      {
        "name": "claimThread",
        "type": "string | Address",
        "typeKind": "address",
        "description": "Optional claim thread for automated claims When provided, validates thread.authority == member_state.authority",
        "optional": true,
        "examples": []
      },
      {
        "name": "computeUnits",
        "type": "number",
        "typeKind": "number",
        "description": "Sets compute units to allocate for the transaction.",
        "optional": true,
        "examples": []
      }
    ]
  },
  {
    "name": "createAffiliate",
    "paramsType": "CreateAffiliateParams",
    "group": "affiliate",
    "isAdmin": false,
    "description": "Register a pending affiliate under a parent Normal member. The affiliate must be activated via `approveAffiliate` before earnings flow.",
    "params": [
      {
        "name": "affiliate",
        "type": "UniversalSigner",
        "typeKind": "signer",
        "description": "The affiliate's wallet - will earn a share of parent's fees Accepts string address, web3.js Keypair, or @solana/kit signer",
        "optional": false,
        "examples": []
      },
      {
        "name": "parentMemberState",
        "type": "string | Address",
        "typeKind": "address",
        "description": "Parent's member state PDA address",
        "optional": false,
        "examples": []
      },
      {
        "name": "nonce",
        "type": "number",
        "typeKind": "number",
        "description": "Optional nonce for the affiliate slot. If not provided, uses vault.nextMemberNonce automatically.",
        "optional": true,
        "examples": []
      },
      {
        "name": "discountAuthority",
        "type": "string | Address | null",
        "typeKind": "address",
        "description": "Optional separate authority for signing discount authorizations. If not provided, discount signing uses the main authority.",
        "optional": true,
        "examples": []
      },
      {
        "name": "computeUnits",
        "type": "number",
        "typeKind": "number",
        "description": "Sets compute units to allocate for the transaction.",
        "optional": true,
        "examples": []
      }
    ]
  },
  {
    "name": "createDiscount",
    "paramsType": "CreateDiscountParams",
    "group": "affiliate",
    "isAdmin": false,
    "description": "Sign and serialize a discount authorization. Server-side helper that lets a designated authority pre-grant a fee discount, which the holder can later attach to a vault deposit to redeem.",
    "params": [
      {
        "name": "memberAddress",
        "type": "string | Address",
        "typeKind": "address",
        "description": "Affiliate member state PDA address",
        "optional": false,
        "examples": []
      },
      {
        "name": "contextKey",
        "type": "string | Address",
        "typeKind": "address",
        "description": "Borrower wallet address (discount is bound to this address)",
        "optional": false,
        "examples": []
      },
      {
        "name": "discountBps",
        "type": "number",
        "typeKind": "number",
        "description": "Discount basis points (10000 = 100%)",
        "optional": false,
        "examples": []
      },
      {
        "name": "expirySeconds",
        "type": "number",
        "typeKind": "number",
        "description": "Seconds from now until discount expires",
        "optional": false,
        "examples": []
      },
      {
        "name": "discountAuthority",
        "type": "string | number[] | Uint8Array | MessageSigner",
        "typeKind": "address",
        "description": "The discount authority signer\n\nAccepts: - A KeyPairSigner from @solana/kit - A Uint8Array or number[] of 64 bytes (secret key) - A JSON stringified keypair: \"[1,2,3,...64 bytes]\"",
        "optional": false,
        "examples": []
      }
    ]
  },
  {
    "name": "removeAffiliate",
    "paramsType": "RemoveAffiliateParams",
    "group": "affiliate",
    "isAdmin": true,
    "description": "Remove an affiliate, sweep their remaining balance, and close the account. Callable by either the affiliate authority or the parent member authority.",
    "params": [
      {
        "name": "authority",
        "type": "UniversalSigner",
        "typeKind": "signer",
        "description": "Authority removing the affiliate (affiliate or parent member authority) Accepts string address, web3.js Keypair, or @solana/kit signer",
        "optional": false,
        "examples": []
      },
      {
        "name": "mint",
        "type": "string | Address",
        "typeKind": "address",
        "description": "Token mint address",
        "optional": false,
        "examples": []
      },
      {
        "name": "vault",
        "type": "string | Address",
        "typeKind": "address",
        "description": "Vault address",
        "optional": false,
        "examples": []
      },
      {
        "name": "affiliateAuthority",
        "type": "string | Address",
        "typeKind": "address",
        "description": "Affiliate authority who receives rent refund",
        "optional": false,
        "examples": []
      },
      {
        "name": "affiliateState",
        "type": "string | Address",
        "typeKind": "address",
        "description": "Affiliate state address to remove",
        "optional": false,
        "examples": []
      },
      {
        "name": "memberState",
        "type": "string | Address",
        "typeKind": "address",
        "description": "Optional parent member state (if parent is removing)",
        "optional": true,
        "examples": []
      },
      {
        "name": "computeUnits",
        "type": "number",
        "typeKind": "number",
        "description": "Sets compute units to allocate for the transaction.",
        "optional": true,
        "examples": []
      }
    ]
  },
  {
    "name": "updateAffiliate",
    "paramsType": "UpdateAffiliateParams",
    "group": "affiliate",
    "isAdmin": true,
    "description": "Update an affiliate's discount-signing authority or transfer the affiliate seat to a new wallet.",
    "params": [
      {
        "name": "authority",
        "type": "UniversalSigner",
        "typeKind": "signer",
        "description": "Current affiliate authority Accepts string address, web3.js Keypair, or @solana/kit signer",
        "optional": false,
        "examples": []
      },
      {
        "name": "affiliateState",
        "type": "string | Address",
        "typeKind": "address",
        "description": "Affiliate member state PDA address",
        "optional": false,
        "examples": []
      },
      {
        "name": "discountAuthority",
        "type": "string | Address | null",
        "typeKind": "address",
        "description": "Update the discount authority: - undefined: leave unchanged - null: clear the discount authority (use main authority for discount signing) - Address: set new discount authority",
        "optional": true,
        "examples": []
      },
      {
        "name": "newAuthority",
        "type": "UniversalSigner",
        "typeKind": "signer",
        "description": "New authority to transfer affiliate control to Must sign the transaction if provided",
        "optional": true,
        "examples": []
      },
      {
        "name": "computeUnits",
        "type": "number",
        "typeKind": "number",
        "description": "Sets compute units to allocate for the transaction.",
        "optional": true,
        "examples": []
      }
    ]
  },
  {
    "name": "claimBorrower",
    "paramsType": "ClaimBorrowerParams",
    "group": "borrower",
    "isAdmin": false,
    "description": "Claim ATLAS refunds and bonuses owed to a borrower.\n\nSweeps the borrower's managed ATA — accumulated bid refunds and knockoff bonuses from reservations — into their personal wallet.",
    "params": [
      {
        "name": "payer",
        "type": "UniversalSigner",
        "typeKind": "signer",
        "description": "Payer for the transaction (signs and pays fees) Accepts string address, web3.js Keypair, or @solana/kit signer",
        "optional": false,
        "examples": []
      },
      {
        "name": "borrower",
        "type": "string | Address",
        "typeKind": "address",
        "description": "Borrower whose ATLAS to claim (optional) If not provided, defaults to the payer's address. This allows a third party to pay for the claim transaction on behalf of the borrower.",
        "optional": true,
        "examples": []
      },
      {
        "name": "close",
        "type": "boolean",
        "typeKind": "boolean",
        "description": "If true, also close the managed ATA and BorrowerState after claiming. Bundles a closeBorrower instruction in the same transaction. Requires no active rentals **and** that `payer` is the borrower — only the borrower may authorize a close.",
        "optional": true,
        "examples": [],
        "defaultValue": "```ts\nfalse\n```"
      },
      {
        "name": "computeUnits",
        "type": "number",
        "typeKind": "number",
        "description": "Sets compute units to allocate for the transaction.",
        "optional": true,
        "examples": [
          "```ts\n400000\n```"
        ]
      }
    ],
    "resultAccount": {
      "accountIndex": 4,
      "keysCount": 10
    }
  },
  {
    "name": "closeBorrower",
    "paramsType": "CloseBorrowerParams",
    "group": "borrower",
    "isAdmin": false,
    "description": "Close a borrower's managed ATA + BorrowerState PDA, refunding rent to the borrower wallet. Borrower-only — call `claimBorrower` first to sweep any remaining ATLAS.",
    "params": [
      {
        "name": "borrower",
        "type": "UniversalSigner",
        "typeKind": "signer",
        "description": "Borrower wallet — sole signer. Authorizes the close, pays the transaction fee, and receives all reclaimed rent. Accepts string address, web3.js Keypair, or @solana/kit signer.",
        "optional": false,
        "examples": []
      },
      {
        "name": "computeUnits",
        "type": "number",
        "typeKind": "number",
        "description": "Sets compute units to allocate for the transaction.",
        "optional": true,
        "examples": [
          "```ts\n200000\n```"
        ]
      }
    ],
    "resultAccount": {
      "accountIndex": 3,
      "keysCount": 7
    }
  },
  {
    "name": "createBorrower",
    "paramsType": "CreateBorrowerParams",
    "group": "borrower",
    "isAdmin": false,
    "description": "Initialize a borrower: a BorrowerState PDA plus a managed ATLAS ATA used to hold reservation bid refunds and knockoff bonuses.",
    "params": [
      {
        "name": "borrower",
        "type": "UniversalSigner",
        "typeKind": "signer",
        "description": "Borrower wallet (pays for account creation) Accepts string address, web3.js Keypair, or @solana/kit signer",
        "optional": false,
        "examples": []
      },
      {
        "name": "computeUnits",
        "type": "number",
        "typeKind": "number",
        "description": "Sets compute units to allocate for the transaction.",
        "optional": true,
        "examples": [
          "```ts\n400000\n```"
        ]
      }
    ],
    "resultAccount": {
      "accountIndex": 3,
      "keysCount": 8
    }
  },
  {
    "name": "deleteBorrower",
    "paramsType": "DeleteBorrowerParams",
    "group": "borrower",
    "isAdmin": true,
    "description": "Admin escape hatch to delete an unparseable BorrowerState (used during schema migrations). Returns rent to the borrower wallet.",
    "params": [
      {
        "name": "admin",
        "type": "UniversalSigner",
        "typeKind": "signer",
        "description": "Admin authority (must be config.admin) Accepts string address, web3.js Keypair, or @solana/kit signer",
        "optional": false,
        "examples": []
      },
      {
        "name": "borrower",
        "type": "string | Address",
        "typeKind": "address",
        "description": "Borrower wallet address who will receive the lamport refund",
        "optional": false,
        "examples": []
      },
      {
        "name": "borrowerState",
        "type": "string | Address",
        "typeKind": "address",
        "description": "BorrowerState PDA address to delete",
        "optional": false,
        "examples": []
      },
      {
        "name": "computeUnits",
        "type": "number",
        "typeKind": "number",
        "description": "Sets compute units to allocate for the transaction.",
        "optional": true,
        "examples": [
          "```ts\n100000\n```"
        ]
      }
    ],
    "resultAccount": {
      "accountIndex": 3,
      "keysCount": 4
    }
  },
  {
    "name": "deleteConfig",
    "paramsType": "DeleteConfigParams",
    "group": "config",
    "isAdmin": true,
    "description": "Delete the program's global config + vault. Destructive — halts all program operations until `createConfig` runs again. Authorized initializer only.",
    "params": [
      {
        "name": "authority",
        "type": "UniversalSigner",
        "typeKind": "signer",
        "description": "Authority who can delete the config (must be AUTHORIZED_INITIALIZER) Accepts string address, web3.js Keypair, or @solana/kit signer Defaults to the hardcoded AUTHORIZED_INITIALIZER if not provided",
        "optional": true,
        "examples": []
      },
      {
        "name": "mint",
        "type": "string | Address",
        "typeKind": "address",
        "description": "Token mint for the vault (optional) If not provided, auto-fetched from on-chain config. Falls back to hardcoded addresses if config fetch fails.",
        "optional": true,
        "examples": []
      },
      {
        "name": "computeUnits",
        "type": "number",
        "typeKind": "number",
        "description": "Sets compute units to allocate for the transaction.",
        "optional": true,
        "examples": [
          "```ts\n200000\n```"
        ]
      }
    ],
    "resultAccount": {
      "accountIndex": 1,
      "keysCount": 9
    }
  },
  {
    "name": "updateConfig",
    "paramsType": "UpdateConfigParams",
    "group": "config",
    "isAdmin": true,
    "description": "Update one or more global program settings. All fields are optional — only the ones you supply change.",
    "params": [
      {
        "name": "admin",
        "type": "UniversalSigner",
        "typeKind": "signer",
        "description": "Admin who has permission to update config Accepts string address, web3.js Keypair, or @solana/kit signer",
        "optional": false,
        "examples": []
      },
      {
        "name": "newAdmin",
        "type": "string | Address | null",
        "typeKind": "address",
        "description": "New admin address (updates the admin)",
        "optional": true,
        "examples": []
      },
      {
        "name": "stardustToAtlas",
        "type": "number | bigint | null",
        "typeKind": "unknown",
        "description": "Stardust to ATLAS conversion rate",
        "optional": true,
        "examples": []
      },
      {
        "name": "serviceFeeBps",
        "type": "number | bigint | null",
        "typeKind": "unknown",
        "description": "Service fee in basis points (1000 = 10%)",
        "optional": true,
        "examples": []
      },
      {
        "name": "baseBps",
        "type": "number | null",
        "typeKind": "unknown",
        "description": "Basis points denominator",
        "optional": true,
        "examples": []
      },
      {
        "name": "rentalDurationMinSeconds",
        "type": "number | bigint | null",
        "typeKind": "unknown",
        "description": "Minimum rental duration in seconds",
        "optional": true,
        "examples": []
      },
      {
        "name": "rentalDurationMaxSeconds",
        "type": "number | bigint | null",
        "typeKind": "unknown",
        "description": "Maximum rental duration in seconds",
        "optional": true,
        "examples": []
      },
      {
        "name": "atlasMint",
        "type": "string | Address | null",
        "typeKind": "address",
        "description": "ATLAS token mint address",
        "optional": true,
        "examples": []
      },
      {
        "name": "reservationsEnabled",
        "type": "boolean | null",
        "typeKind": "unknown",
        "description": "Whether reservation system is enabled",
        "optional": true,
        "examples": []
      },
      {
        "name": "pointsPerDay",
        "type": "number | null",
        "typeKind": "unknown",
        "description": "Capture points awarded per day of rental",
        "optional": true,
        "examples": []
      },
      {
        "name": "maxCapturePoints",
        "type": "number | bigint | null",
        "typeKind": "unknown",
        "description": "Ceiling on a borrower's capture_points balance. A borrower at or above it earns nothing until spending drops them below.",
        "optional": true,
        "examples": []
      },
      {
        "name": "minCaptureThreshold",
        "type": "number | null",
        "typeKind": "unknown",
        "description": "Minimum points needed to capture a flag",
        "optional": true,
        "examples": []
      },
      {
        "name": "reservationCooldownSeconds",
        "type": "number | null",
        "typeKind": "unknown",
        "description": "Seconds a queued reservation is protected from being displaced by a points bid. ATLAS bids are never gated. 0 disables the gate.",
        "optional": true,
        "examples": []
      },
      {
        "name": "captureRateBps",
        "type": "number | bigint | null",
        "typeKind": "unknown",
        "description": "Rate increase in basis points after capture (10000 = 100%, 11000 = 110%)",
        "optional": true,
        "examples": []
      },
      {
        "name": "atlasPerPoint",
        "type": "number | bigint | null",
        "typeKind": "unknown",
        "description": "ATLAS lamports per point equivalent for reservation bidding",
        "optional": true,
        "examples": []
      },
      {
        "name": "contestedMultiplierMaxBps",
        "type": "number | null",
        "typeKind": "unknown",
        "description": "Maximum floor multiplier in basis points (100 = 1×, 465 = 4.65×). 100 disables the snipe ramp; 100..=10000 enables it.",
        "optional": true,
        "examples": []
      },
      {
        "name": "staleDiscountPerDayBps",
        "type": "number | null",
        "typeKind": "unknown",
        "description": "Daily stale-discount in bps (e.g. 200 = 2%/day off the stored rate per idle day). `0` disables the mechanic protocol-wide. Combines with each contract's `stale_discount_max_bps` to cap the total decay. Range 0..=10_000.",
        "optional": true,
        "examples": []
      },
      {
        "name": "bonusMultiplierBps",
        "type": "number | null",
        "typeKind": "unknown",
        "description": "Knockoff-bonus multiplier in bps on a custom scale where `100` = 1× (no-op) and `10_000` = 100×. Scales the same-currency contest bonus; the payout stays capped at the bid diff, so larger values just reach that cap sooner. Range 100..=10_000.",
        "optional": true,
        "examples": []
      },
      {
        "name": "computeUnits",
        "type": "number",
        "typeKind": "number",
        "description": "Sets compute units to allocate for the transaction.",
        "optional": true,
        "examples": [
          "```ts\n400000\n```"
        ]
      }
    ],
    "resultAccount": {
      "accountIndex": 1,
      "keysCount": 2
    }
  },
  {
    "name": "claimContract",
    "paramsType": "ClaimContractParams",
    "group": "contract",
    "isAdmin": false,
    "description": "Sweep a contract's accumulated ATLAS earnings into the owner's ATA. Permissionless — anyone can trigger; funds always land at the owner's ATA.",
    "params": [
      {
        "name": "payer",
        "type": "UniversalSigner",
        "typeKind": "signer",
        "description": "Payer for the transaction (pays ATA init if needed). Permissionless — any wallet can trigger a claim. Accepts string address, web3.js Keypair, or @solana/kit signer",
        "optional": false,
        "examples": []
      },
      {
        "name": "contract",
        "type": "string | Address",
        "typeKind": "address",
        "description": "Contract address to claim from",
        "optional": false,
        "examples": []
      },
      {
        "name": "computeUnits",
        "type": "number",
        "typeKind": "number",
        "description": "Sets compute units to allocate for the transaction.",
        "optional": true,
        "examples": [
          "```ts\n400000\n```"
        ]
      }
    ],
    "resultAccount": {
      "accountIndex": 4,
      "keysCount": 10
    }
  },
  {
    "name": "closeContract",
    "paramsType": "CloseContractParams",
    "group": "contract",
    "isAdmin": false,
    "description": "Close a rental contract and refund rent to the owner. Whenever the close finishes in this transaction, the contract's automation thread is torn down in the same one — the on-chain immediate-close branch refuses to run while `contract.thread` still names a live thread.\n\nA live rental cannot be closed out from under its borrower, so the close is latched as `to_close` and completed later by the automation thread, once the rental ends. On that path the thread is deliberately left running: it is the only thing that can act on the flag. Antegen execution is permissionless and executors are paid from the thread's own lamport balance, so a drained thread can be revived by anyone with a plain SOL transfer — the owner does not need to come back.\n\nSafe to retry while the close is still pending: a repeat call is a no-op that re-latches the flag. It is *not* a no-op after a successful full close — the contract account is gone, so the next call fails during account validation. That reverts cleanly, burning no rent.",
    "params": [
      {
        "name": "owner",
        "type": "UniversalSigner",
        "typeKind": "signer",
        "description": "Contract owner (must be the original owner) Accepts string address, web3.js Keypair, or @solana/kit signer",
        "optional": false,
        "examples": []
      },
      {
        "name": "contract",
        "type": "string | Address",
        "typeKind": "address",
        "description": "Contract address to close (optional - derived from fleet PDA if not provided) Either contract or fleet must be provided NOTE: If using contract only, it must already exist (will be fetched to get fleet)",
        "optional": true,
        "examples": []
      },
      {
        "name": "fleet",
        "type": "string | Address",
        "typeKind": "address",
        "description": "SAGE fleet address (optional - fetched from contract if not provided) Either contract or fleet must be provided RECOMMENDED: Use fleet for idempotent behavior (contract created if needed)",
        "optional": true,
        "examples": []
      },
      {
        "name": "sageProgram",
        "type": "string | Address",
        "typeKind": "address",
        "description": "SAGE program address (optional - uses config default if not provided)",
        "optional": true,
        "examples": []
      },
      {
        "name": "queuedBorrower",
        "type": "string | Address",
        "typeKind": "address",
        "description": "Borrower address for the queued rental (optional - auto-fetched if not provided) Only needed when a queued rental exists",
        "optional": true,
        "examples": []
      },
      {
        "name": "computeUnits",
        "type": "number",
        "typeKind": "number",
        "description": "Sets compute units to allocate for the transaction.",
        "optional": true,
        "examples": [
          "```ts\n400000\n```"
        ]
      },
      {
        "name": "snapshot",
        "type": "ContractSnapshot",
        "typeKind": "unknown",
        "description": "Optional pre-fetched `ContractSnapshot`. When supplied, skips the aggregated RPC fetch. If the snapshot is stale (contract pointer set but rental account null), the SDK lazy-refetches once and throws if still inconsistent. Ignored when `contract` is not provided and the address must be derived from `fleet`.",
        "optional": true,
        "examples": []
      }
    ],
    "resultAccount": {
      "accountIndex": 3,
      "keysCount": 17
    },
    "requiresOneOf": [
      [
        "contract",
        "fleet"
      ]
    ]
  },
  {
    "name": "closeContractThread",
    "paramsType": "CloseContractThreadParams",
    "group": "contract",
    "isAdmin": false,
    "description": "Close a contract's automation thread and all of its fibers, reclaiming rent to the owner.",
    "params": [
      {
        "name": "owner",
        "type": "UniversalSigner",
        "typeKind": "signer",
        "description": "Contract owner (must be the contract's owner) Accepts string address, web3.js Keypair, or @solana/kit signer",
        "optional": false,
        "examples": []
      },
      {
        "name": "contract",
        "type": "string | Address",
        "typeKind": "address",
        "description": "Contract address whose thread to close",
        "optional": false,
        "examples": []
      },
      {
        "name": "computeUnits",
        "type": "number",
        "typeKind": "number",
        "description": "Sets compute units to allocate for the transaction.",
        "optional": true,
        "examples": [
          "```ts\n400000\n```"
        ]
      }
    ],
    "resultAccount": {
      "accountIndex": 3,
      "keysCount": 7
    }
  },
  {
    "name": "createContract",
    "paramsType": "CreateContractParams",
    "group": "contract",
    "isAdmin": false,
    "description": "List a Star Atlas fleet for rent. Sets the per-period rate, allowed duration window, fee, and (optionally) automation parameters.",
    "params": [
      {
        "name": "owner",
        "type": "UniversalSigner",
        "typeKind": "signer",
        "description": "Fleet owner who will receive rental payments Accepts string address, web3.js Keypair, or @solana/kit signer",
        "optional": false,
        "examples": []
      },
      {
        "name": "fleet",
        "type": "string | Address",
        "typeKind": "address",
        "description": "Fleet address to be rented out Must be a valid Star Atlas SAGE fleet The fleet's ownerProfile and gameId will be fetched automatically",
        "optional": false,
        "examples": []
      },
      {
        "name": "rate",
        "type": "AmountParam",
        "typeKind": "amount",
        "description": "Rental rate per payment period. Accepts a plain number / bigint (stardust), `{ atlas: number }`, or `{ stardust: number | bigint }`.",
        "optional": false,
        "examples": [
          "```ts\n{ atlas: 100 } // 100 ATLAS\n```",
          "```ts\n{ atlas: 1.5 } // 1.5 ATLAS\n```",
          "```ts\n{ stardust: 150_000_000 } // Explicit stardust (smallest unit)\n```"
        ]
      },
      {
        "name": "durationMin",
        "type": "DurationParam",
        "typeKind": "duration",
        "description": "Minimum rental duration",
        "optional": true,
        "examples": [
          "```ts\n{ hours: 1 } // 1 hour minimum\n```",
          "```ts\n{ days: 1 } // 1 day minimum\n```",
          "```ts\n3600 // 1 hour in seconds\n```"
        ]
      },
      {
        "name": "durationMax",
        "type": "DurationParam",
        "typeKind": "duration",
        "description": "Maximum rental duration",
        "optional": false,
        "examples": [
          "```ts\n{ days: 30 } // 30 day maximum\n```",
          "```ts\n{ months: 3 } // 3 month maximum\n```",
          "```ts\n2592000 // 30 days in seconds\n```"
        ]
      },
      {
        "name": "ownerKeyIndex",
        "type": "number",
        "typeKind": "number",
        "description": "Owner's key index in SAGE",
        "optional": true,
        "examples": [],
        "defaultValue": "```ts\n0\n```"
      },
      {
        "name": "cancelDelayMin",
        "type": "DurationParam",
        "typeKind": "duration",
        "description": "Minimum cancellation delay required for borrowers. Defaults to `durationMin` if omitted, so the borrower can never exit a rental earlier than the contract's own minimum lease window. Set explicitly to allow earlier (or later) cancellation.",
        "optional": true,
        "examples": [
          "```ts\n{ hours: 0 } // Allow instant cancellation\n```",
          "```ts\n{ hours: 1 } // Minimum 1 hour delay\n```",
          "```ts\n{ days: 1 } // Minimum 1 day delay\n```"
        ],
        "defaultValue": "```ts\ndurationMin // matches the contract's minimum rental duration\n```"
      },
      {
        "name": "reservationsDisabled",
        "type": "boolean",
        "typeKind": "boolean",
        "description": "Whether reservations are disabled for this contract When true, other borrowers cannot reserve this contract. Set to false to enable the reservation system.",
        "optional": true,
        "examples": [],
        "defaultValue": "```ts\ntrue\n```"
      },
      {
        "name": "contestedThreshold",
        "type": "number",
        "typeKind": "number",
        "description": "Number of contests that must accumulate before the contract rate auto-increments by `capture_rate_bps`. Owner-tunable per contract.\n\n- `0` disables capture-rate entirely (rate stays fixed forever). - `1..=10` enables it with the chosen sensitivity.",
        "optional": true,
        "examples": [],
        "defaultValue": "```ts\n1\n```"
      },
      {
        "name": "staleDiscountMaxBps",
        "type": "number",
        "typeKind": "number",
        "description": "Per-contract cap on the stale-discount writeback (bps). - `0` disables the mechanic for this contract (rate never decays). - `5_000` allows up to 50% discount; rate floored at 50% of stored value. - `10_000` removes the per-contract cap (still clamped to the program-wide minimum rate at writeback). Range 0..=10_000.",
        "optional": true,
        "examples": [],
        "defaultValue": "```ts\n0 // opt-in only\n```"
      },
      {
        "name": "automated",
        "type": "boolean",
        "typeKind": "boolean",
        "description": "Enable contract automation thread. When true, bundles createContractThread into the same transaction. Set to false for manual-mode contracts without automation.",
        "optional": true,
        "examples": [],
        "defaultValue": "```ts\ntrue\n```"
      },
      {
        "name": "paymentsFreq",
        "type": "string",
        "typeKind": "string",
        "description": "Payment processing frequency — required when automated is true",
        "optional": true,
        "examples": [
          "```ts\n'hourly'\n```",
          "```ts\n'@daily'\n```",
          "```ts\n'0 0 6 * * *' — every day at 6am\n```"
        ],
        "defaultValue": "```ts\n'@daily'\n```"
      },
      {
        "name": "threadLamports",
        "type": "SolParam",
        "typeKind": "unknown",
        "description": "Additional SOL preload for thread execution fees (on top of 0.04 SOL base). Only used when automated is true. When omitted, the SDK preloads enough lamports to cover ~1 year of `@daily` cron ticks. Accepts a plain number / bigint (lamports), `{ sol: number }`, or `{ lamports: number | bigint }`.",
        "optional": true,
        "examples": [
          "```ts\n{ sol: 0.1 } // 0.1 SOL extra\n```",
          "```ts\n{ lamports: 50_000_000 }\n```"
        ],
        "defaultValue": "```ts\n{ sol: 0.00219 } // ~1 year of `@daily` triggers\n```"
      },
      {
        "name": "computeUnits",
        "type": "number",
        "typeKind": "number",
        "description": "Sets compute units to allocate for the transaction.",
        "optional": true,
        "examples": [
          "```ts\n400000\n```"
        ]
      }
    ],
    "resultAccount": {
      "accountIndex": 6,
      "keysCount": 15
    }
  },
  {
    "name": "createContractThread",
    "paramsType": "CreateContractThreadParams",
    "group": "contract",
    "isAdmin": false,
    "description": "Set up the per-contract automation thread that processes payments and lifecycle ticks. Thread starts paused; the rental_close and rental_activate fibers spin up lazily on first use.",
    "params": [
      {
        "name": "owner",
        "type": "UniversalSigner",
        "typeKind": "signer",
        "description": "Contract owner (must be the contract's owner) Accepts string address, web3.js Keypair, or @solana/kit signer",
        "optional": false,
        "examples": []
      },
      {
        "name": "contract",
        "type": "string | Address",
        "typeKind": "address",
        "description": "Contract address to create thread for",
        "optional": false,
        "examples": []
      },
      {
        "name": "lamports",
        "type": "SolParam",
        "typeKind": "unknown",
        "description": "Additional SOL preload for thread execution fees. Added on top of the 0.04 SOL base minimum (3 fibers + thread rent). When omitted, the SDK preloads enough lamports to cover ~1 year of `@daily` cron ticks. Accepts a plain number / bigint (lamports), `{ sol: number }`, or `{ lamports: number | bigint }`.",
        "optional": true,
        "examples": [
          "```ts\n{ sol: 0.1 } // 0.1 SOL extra\n```",
          "```ts\n{ lamports: 50_000_000 }\n```"
        ],
        "defaultValue": "```ts\n{ sol: 0.00219 } // ~1 year of `@daily` triggers\n```"
      },
      {
        "name": "paymentsFreq",
        "type": "string",
        "typeKind": "string",
        "description": "Payment processing frequency (cron expression or named schedule)",
        "optional": false,
        "examples": []
      },
      {
        "name": "computeUnits",
        "type": "number",
        "typeKind": "number",
        "description": "Sets compute units to allocate for the transaction.",
        "optional": true,
        "examples": [
          "```ts\n400000\n```"
        ]
      }
    ]
  },
  {
    "name": "deleteContract",
    "paramsType": "DeleteContractParams",
    "group": "contract",
    "isAdmin": true,
    "description": "Admin escape hatch to delete a corrupted ContractState (used during schema migrations). Returns rent to the contract owner.",
    "params": [
      {
        "name": "admin",
        "type": "UniversalSigner",
        "typeKind": "signer",
        "description": "Admin authority (must be config.admin) Accepts string address, web3.js Keypair, or @solana/kit signer",
        "optional": false,
        "examples": []
      },
      {
        "name": "owner",
        "type": "string | Address",
        "typeKind": "address",
        "description": "Owner wallet address who will receive the lamport refund Optional - auto-fetched from contract if not provided Required if contract state is corrupted and cannot be deserialized",
        "optional": true,
        "examples": []
      },
      {
        "name": "contract",
        "type": "string | Address",
        "typeKind": "address",
        "description": "Contract state address to delete This is the contract account that cannot be deserialized",
        "optional": false,
        "examples": []
      },
      {
        "name": "computeUnits",
        "type": "number",
        "typeKind": "number",
        "description": "Sets compute units to allocate for the transaction.",
        "optional": true,
        "examples": [
          "```ts\n100000\n```"
        ]
      }
    ],
    "resultAccount": {
      "accountIndex": 3,
      "keysCount": 4
    }
  },
  {
    "name": "deleteContractThread",
    "paramsType": "DeleteContractThreadParams",
    "group": "contract",
    "isAdmin": true,
    "description": "Admin variant of `closeContractThread` that doesn't require the contract account on-chain — used when the contract is already deleted or unparseable.",
    "params": [
      {
        "name": "admin",
        "type": "UniversalSigner",
        "typeKind": "signer",
        "description": "Admin authority (must be config.admin) Accepts string address, web3.js Keypair, or @solana/kit signer",
        "optional": false,
        "examples": []
      },
      {
        "name": "contract",
        "type": "string | Address",
        "typeKind": "address",
        "description": "Contract address whose thread to delete (used to derive thread PDA)",
        "optional": false,
        "examples": []
      },
      {
        "name": "computeUnits",
        "type": "number",
        "typeKind": "number",
        "description": "Sets compute units to allocate for the transaction.",
        "optional": true,
        "examples": [
          "```ts\n400000\n```"
        ]
      }
    ],
    "resultAccount": {
      "accountIndex": 3,
      "keysCount": 7
    }
  },
  {
    "name": "migrateContract",
    "paramsType": "MigrateContractParams",
    "group": "contract",
    "isAdmin": false,
    "description": "Build the migrate_contract instruction.\n\nIdempotent: safe to re-submit. The on-chain handler short-circuits to Ok if the ContractState is already at version 2.",
    "params": [
      {
        "name": "payer",
        "type": "UniversalSigner",
        "typeKind": "signer",
        "description": "Signer that pays the realloc rent. Permissionless — does not need to be the contract owner.",
        "optional": false,
        "examples": []
      },
      {
        "name": "contract",
        "type": "string | Address",
        "typeKind": "address",
        "description": "Contract state address to migrate.",
        "optional": false,
        "examples": []
      },
      {
        "name": "computeUnits",
        "type": "number",
        "typeKind": "number",
        "description": "Sets compute units to allocate for the transaction.",
        "optional": true,
        "examples": []
      }
    ],
    "resultAccount": {
      "accountIndex": 1,
      "keysCount": 3
    }
  },
  {
    "name": "setDelegate",
    "paramsType": "SetDelegateParams",
    "group": "contract",
    "isAdmin": false,
    "description": "Set or clear a delegate that may update a contract's rate. Owner-only.",
    "params": [
      {
        "name": "owner",
        "type": "UniversalSigner",
        "typeKind": "signer",
        "description": "Contract owner (must be the original owner) Accepts string address, web3.js Keypair, or @solana/kit signer",
        "optional": false,
        "examples": []
      },
      {
        "name": "contract",
        "type": "string | Address",
        "typeKind": "address",
        "description": "Contract address to update",
        "optional": false,
        "examples": []
      },
      {
        "name": "delegate",
        "type": "string | Address | null",
        "typeKind": "address",
        "description": "Delegate address to set, or null/undefined to remove delegate The delegate can update the contract rate on behalf of the owner",
        "optional": true,
        "examples": []
      },
      {
        "name": "computeUnits",
        "type": "number",
        "typeKind": "number",
        "description": "Sets compute units to allocate for the transaction.",
        "optional": true,
        "examples": [
          "```ts\n400000\n```"
        ]
      }
    ],
    "resultAccount": {
      "accountIndex": 1,
      "keysCount": 2
    }
  },
  {
    "name": "updateContract",
    "paramsType": "UpdateContractParams",
    "group": "contract",
    "isAdmin": false,
    "description": "Update an existing contract's settings. Owners can change any field; delegates may only adjust the rate.",
    "params": [
      {
        "name": "authority",
        "type": "UniversalSigner",
        "typeKind": "signer",
        "description": "Contract authority (owner or delegate) Delegates can only update the rate field. Accepts string address, web3.js Keypair, or @solana/kit signer",
        "optional": false,
        "examples": []
      },
      {
        "name": "contract",
        "type": "string | Address",
        "typeKind": "address",
        "description": "Contract address to update",
        "optional": false,
        "examples": []
      },
      {
        "name": "rate",
        "type": "AmountParam",
        "typeKind": "amount",
        "description": "New rental rate per payment period (optional). Accepts a plain number / bigint (stardust), `{ atlas: number }`, or `{ stardust: number | bigint }`.",
        "optional": true,
        "examples": [
          "```ts\n{ atlas: 100 } // 100 ATLAS\n```",
          "```ts\n{ atlas: 1.5 } // 1.5 ATLAS\n```",
          "```ts\n{ stardust: 150_000_000 } // Explicit stardust (smallest unit)\n```"
        ]
      },
      {
        "name": "durationMin",
        "type": "DurationParam",
        "typeKind": "duration",
        "description": "New minimum rental duration (optional)",
        "optional": true,
        "examples": [
          "```ts\n{ hours: 1 } // 1 hour minimum\n```",
          "```ts\n{ days: 1 } // 1 day minimum\n```",
          "```ts\n3600 // 1 hour in seconds\n```"
        ]
      },
      {
        "name": "durationMax",
        "type": "DurationParam",
        "typeKind": "duration",
        "description": "New maximum rental duration (optional)",
        "optional": true,
        "examples": [
          "```ts\n{ days: 30 } // 30 day maximum\n```",
          "```ts\n{ months: 3 } // 3 month maximum\n```",
          "```ts\n2592000 // 30 days in seconds\n```"
        ]
      },
      {
        "name": "cancelDelayMin",
        "type": "DurationParam",
        "typeKind": "duration",
        "description": "Minimum cancellation delay (optional) Set to 0 or { seconds: 0 } to allow instant cancellation. Set to a duration like { hours: 1 } to require advance notice.",
        "optional": true,
        "examples": [
          "```ts\n{ hours: 1 } // Require 1 hour notice\n```",
          "```ts\n{ seconds: 0 } // Allow instant cancel\n```",
          "```ts\n3600 // 1 hour in seconds\n```"
        ]
      },
      {
        "name": "reservationsDisabled",
        "type": "boolean",
        "typeKind": "boolean",
        "description": "Whether reservations are disabled for this contract When enabled, other borrowers cannot reserve this contract. Owners can use this to opt out of the reservation system.",
        "optional": true,
        "examples": []
      },
      {
        "name": "toClose",
        "type": "boolean",
        "typeKind": "boolean",
        "description": "Cancel or re-enable deferred contract closure (optional, owner only) Set to false to cancel a pending close (reverts contract_close when rental was active). Set to true to flag contract for closure after current rental ends.",
        "optional": true,
        "examples": []
      },
      {
        "name": "contestedThreshold",
        "type": "number",
        "typeKind": "number",
        "description": "Number of contests that must accumulate before the contract rate auto-increments by `capture_rate_bps`. Owner-tunable per contract.\n\n- `0` disables capture-rate entirely (rate stays fixed forever). - `1..=10` enables it with the chosen sensitivity.",
        "optional": true,
        "examples": []
      },
      {
        "name": "staleDiscountMaxBps",
        "type": "number | null",
        "typeKind": "unknown",
        "description": "Per-contract cap on the stale-discount writeback (bps). Range 0..=10_000. `0` disables decay for this contract; higher values let the rate drift down by up to `max_bps` over idle time. Applies on the next `rental_accept` writeback.",
        "optional": true,
        "examples": []
      },
      {
        "name": "computeUnits",
        "type": "number",
        "typeKind": "number",
        "description": "Sets compute units to allocate for the transaction.",
        "optional": true,
        "examples": [
          "```ts\n400000\n```"
        ]
      }
    ],
    "resultAccount": {
      "accountIndex": 2,
      "keysCount": 3
    }
  },
  {
    "name": "updateContractThread",
    "paramsType": "UpdateContractThreadParams",
    "group": "contract",
    "isAdmin": false,
    "description": "Top up a contract thread's lamports balance and (optionally) reschedule its payment frequency.",
    "params": [
      {
        "name": "owner",
        "type": "UniversalSigner",
        "typeKind": "signer",
        "description": "Contract owner (payer for additional lamports) Accepts string address, web3.js Keypair, or @solana/kit signer",
        "optional": false,
        "examples": []
      },
      {
        "name": "contract",
        "type": "string | Address",
        "typeKind": "address",
        "description": "Contract address whose thread to update",
        "optional": false,
        "examples": []
      },
      {
        "name": "lamports",
        "type": "SolParam",
        "typeKind": "unknown",
        "description": "Additional SOL to top up the thread with. Accepts a plain number / bigint (lamports), `{ sol: number }`, or `{ lamports: number | bigint }`.",
        "optional": true,
        "examples": [
          "```ts\n{ sol: 0.05 } // top up by 0.05 SOL\n```",
          "```ts\n{ lamports: 50_000_000 }\n```"
        ],
        "defaultValue": "```ts\n0 // no additional funding\n```"
      },
      {
        "name": "paymentsFreq",
        "type": "string",
        "typeKind": "string",
        "description": "Optional new payment frequency (cron expression or named schedule)",
        "optional": true,
        "examples": []
      },
      {
        "name": "computeUnits",
        "type": "number",
        "typeKind": "number",
        "description": "Sets compute units to allocate for the transaction.",
        "optional": true,
        "examples": [
          "```ts\n400000\n```"
        ]
      }
    ]
  },
  {
    "name": "contractDoctorFiber",
    "paramsType": "ContractDoctorFiberParams",
    "group": "other",
    "isAdmin": false,
    "description": "Rewrite one of a contract thread's fibers.\n\nNothing on chain keeps a thread's `fiber_ids` and the accounts those indices name in agreement, so a thread can be intact, funded and scheduled and still permanently unable to build — every executor fails with `Fiber <pubkey> not found` and the contract stops settling.\n\nWriting a fiber requires the thread's authority to sign, and for every SRSLY thread that authority is `rental_authority`, a PDA of the SRSLY program. No wallet holds its key, so this instruction is the only route back.\n\nThe payload is supplied rather than rebuilt from contract state: a fiber's compiled instruction captured a specific account set at the moment it was written, and contract state has moved on since.\n\nIdempotent — re-running converges rather than duplicating.",
    "params": [
      {
        "name": "payer",
        "type": "UniversalSigner",
        "typeKind": "signer",
        "description": "Signs and pays rent for the rewritten fiber. Either the contract's owner or `config.admin`. Owners must also pass `contract` — it is what authorizes them, and what scopes the payload to their own contract. Accepts string address, web3.js Keypair, or @solana/kit signer.",
        "optional": false,
        "examples": []
      },
      {
        "name": "contract",
        "type": "string | Address",
        "typeKind": "address",
        "description": "Contract address. Required when `payer` is the owner. Also used to derive the thread when `thread` is not given. Admins may omit it — the program's break-glass path exists precisely for contracts that cannot be read.",
        "optional": true,
        "examples": []
      },
      {
        "name": "thread",
        "type": "string | Address",
        "typeKind": "address",
        "description": "Thread address, supplied directly. Takes precedence over deriving it from `contract` — useful when the thread was found by scanning rather than derived.",
        "optional": true,
        "examples": []
      },
      {
        "name": "fiberIndex",
        "type": "number",
        "typeKind": "number",
        "description": "Which fiber to rewrite. 0 is the controller, 1 is close-rental.",
        "optional": false,
        "examples": []
      },
      {
        "name": "instruction",
        "type": "DoctoredFiberInstruction",
        "typeKind": "unknown",
        "description": "The instruction content to write.",
        "optional": false,
        "examples": []
      },
      {
        "name": "priorityFee",
        "type": "number | bigint | null",
        "typeKind": "unknown",
        "description": "Priority fee to set on the fiber. Omit to leave it unchanged.",
        "optional": true,
        "examples": []
      },
      {
        "name": "computeUnits",
        "type": "number",
        "typeKind": "number",
        "description": "Sets compute units to allocate for the transaction.",
        "optional": true,
        "examples": [
          "```ts\n400000\n```"
        ]
      }
    ]
  },
  {
    "name": "createConfig",
    "paramsType": "CreateConfigParams",
    "group": "other",
    "isAdmin": true,
    "description": "One-time initialization of the global program config. Required before any other instruction can run.",
    "params": [
      {
        "name": "authority",
        "type": "UniversalSigner",
        "typeKind": "signer",
        "description": "Authority who will initialize the config Must be the authorized initializer keypair Accepts web3.js Keypair or @solana/kit signer",
        "optional": false,
        "examples": []
      },
      {
        "name": "vault",
        "type": "string | Address",
        "typeKind": "address",
        "description": "Slyvault address for storing funds",
        "optional": false,
        "examples": []
      },
      {
        "name": "vaultTokenAccount",
        "type": "string | Address",
        "typeKind": "address",
        "description": "Vault's associated token account",
        "optional": false,
        "examples": []
      },
      {
        "name": "lookupTable",
        "type": "string | Address",
        "typeKind": "address",
        "description": "Address Lookup Table account to be created Must be derived from authority + recent slot using the ALT program",
        "optional": false,
        "examples": []
      },
      {
        "name": "recentSlot",
        "type": "number | bigint",
        "typeKind": "unknown",
        "description": "Recent slot used to derive the lookup table address Must match the slot used to derive the lookupTable address",
        "optional": false,
        "examples": []
      },
      {
        "name": "computeUnits",
        "type": "number",
        "typeKind": "number",
        "description": "Sets compute units to allocate for the transaction.",
        "optional": true,
        "examples": [
          "```ts\n400000\n```"
        ]
      }
    ]
  },
  {
    "name": "migrateConfig",
    "paramsType": "MigrateConfigParams",
    "group": "other",
    "isAdmin": false,
    "description": "Build the migrate_config instruction.\n\nIdempotent: safe to re-submit. The on-chain handler short-circuits to Ok if the ConfigState is already at version 2.",
    "params": [
      {
        "name": "payer",
        "type": "UniversalSigner",
        "typeKind": "signer",
        "description": "Signer that pays the realloc rent (~14_000 lamports for the new trailing bytes). Permissionless — does not need to be the program admin.",
        "optional": false,
        "examples": []
      },
      {
        "name": "computeUnits",
        "type": "number",
        "typeKind": "number",
        "description": "Sets compute units to allocate for the transaction.",
        "optional": true,
        "examples": []
      }
    ]
  },
  {
    "name": "acceptRental",
    "paramsType": "AcceptRentalParams",
    "group": "rental",
    "isAdmin": false,
    "description": "Activate a rental: transfer fleet control to the borrower for the chosen duration and pay the first period's rate.",
    "params": [
      {
        "name": "borrower",
        "type": "UniversalSigner",
        "typeKind": "signer",
        "description": "Borrower who will rent the fleet Accepts string address, web3.js Keypair, or @solana/kit signer",
        "optional": false,
        "examples": []
      },
      {
        "name": "borrowerProfile",
        "type": "string | Address",
        "typeKind": "address",
        "description": "Borrower's profile address in Star Atlas SAGE This is the profile that will control the fleet during rental",
        "optional": false,
        "examples": []
      },
      {
        "name": "contract",
        "type": "string | Address",
        "typeKind": "address",
        "description": "Rental contract address to accept",
        "optional": false,
        "examples": []
      },
      {
        "name": "referrer",
        "type": "string | Address",
        "typeKind": "address",
        "description": "Affiliate member state address (optional) If provided, the affiliate receives a portion of fees",
        "optional": true,
        "examples": []
      },
      {
        "name": "duration",
        "type": "DurationParam",
        "typeKind": "duration",
        "description": "Rental duration",
        "optional": false,
        "examples": [
          "```ts\n{ hours: 12 } // 12 hours\n```",
          "```ts\n{ days: 7 } // 7 days\n```",
          "```ts\n{ weeks: 2 } // 2 weeks\n```",
          "```ts\n604800 // 7 days in seconds\n```"
        ]
      },
      {
        "name": "computeUnits",
        "type": "number",
        "typeKind": "number",
        "description": "Sets compute units to allocate for the transaction.",
        "optional": false,
        "examples": [
          "```ts\n400000\n```"
        ]
      },
      {
        "name": "discountAuth",
        "type": "SerializedDiscountAuth",
        "typeKind": "unknown",
        "description": "Discount authorization from createDiscount() — pass directly from API response. No deserialization needed.",
        "optional": true,
        "examples": []
      },
      {
        "name": "rate",
        "type": "AmountParam",
        "typeKind": "amount",
        "description": "Expected rental rate (optional client-side safety check).\n\nIf provided, the SDK will compare this against the on-chain contract rate and throw before building the transaction if they don't match. Useful for detecting rate changes between UI display and transaction submission.\n\nAccepts a plain number / bigint (stardust), `{ atlas: number }`, or `{ stardust: number | bigint }`.",
        "optional": true,
        "examples": [
          "```ts\n{ atlas: 1 } // 1 ATLAS per period\n```",
          "```ts\n{ stardust: 500_000_000 } // 5 ATLAS in stardust (smallest unit)\n```"
        ]
      },
      {
        "name": "expiredBorrowerState",
        "type": "string | Address",
        "typeKind": "address",
        "description": "BorrowerState of the expired rental's borrower (optional)\n\nRequired when accepting a contract that has an expired active rental (inline replacement). If not provided, the SDK will auto-detect by fetching the active rental state.",
        "optional": true,
        "examples": []
      },
      {
        "name": "snapshot",
        "type": "ContractSnapshot",
        "typeKind": "unknown",
        "description": "Optional pre-fetched `ContractSnapshot`. When supplied, skips the aggregated RPC fetch. If the snapshot is stale (contract pointer set but rental account null), the SDK lazy-refetches once and throws if still inconsistent.",
        "optional": true,
        "examples": []
      }
    ],
    "resultAccount": {
      "accountIndex": 7,
      "keysCount": 26
    }
  },
  {
    "name": "cancelRental",
    "paramsType": "CancelRentalParams",
    "group": "rental",
    "isAdmin": false,
    "description": "Cancel an active rental and refund the borrower for unused time. Takes effect immediately or after a delay set by `cancelDelay`.",
    "params": [
      {
        "name": "borrower",
        "type": "UniversalSigner",
        "typeKind": "signer",
        "description": "Borrower who is canceling the rental Accepts string address, web3.js Keypair, or @solana/kit signer",
        "optional": false,
        "examples": []
      },
      {
        "name": "contract",
        "type": "string | Address",
        "typeKind": "address",
        "description": "Contract address to cancel",
        "optional": false,
        "examples": []
      },
      {
        "name": "cancelDelay",
        "type": "DurationParam",
        "typeKind": "duration",
        "description": "Cancellation delay\n\n- 0: Instant cancellation (requires contract.cancelDelayMin = 0) - > 0: Deferred cancellation - rental continues for the specified delay\n\nAccepts seconds as a number, or an object with time units:",
        "optional": true,
        "examples": [
          "```ts\n0 // Instant cancel\n```",
          "```ts\n{ hours: 12 } // Cancel after 12 hours\n```",
          "```ts\n{ days: 1 } // Cancel after 1 day\n```",
          "```ts\n{ weeks: 1 } // Cancel after 1 week\n```"
        ],
        "defaultValue": "```ts\ncontract.cancelDelayMin (fetched on-chain)\n```"
      },
      {
        "name": "computeUnits",
        "type": "number",
        "typeKind": "number",
        "description": "Sets compute units to allocate for the transaction.",
        "optional": true,
        "examples": [
          "```ts\n400000\n```"
        ]
      }
    ]
  },
  {
    "name": "closeRental",
    "paramsType": "CloseRentalParams",
    "group": "rental",
    "isAdmin": false,
    "description": "Finalize a completed rental and return the fleet to the owner.",
    "params": [
      {
        "name": "payer",
        "type": "UniversalSigner",
        "typeKind": "signer",
        "description": "Payer for the transaction (usually the owner) Accepts string address, web3.js Keypair, or @solana/kit signer",
        "optional": false,
        "examples": []
      },
      {
        "name": "contract",
        "type": "string | Address",
        "typeKind": "address",
        "description": "Contract address to close the rental from",
        "optional": false,
        "examples": []
      },
      {
        "name": "borrower",
        "type": "string | Address",
        "typeKind": "address",
        "description": "Borrower address (optional) If not provided, automatically fetched from the active rental state. Falls back to payer if rental state doesn't exist.",
        "optional": true,
        "examples": []
      },
      {
        "name": "activateQueued",
        "type": "boolean",
        "typeKind": "boolean",
        "description": "Promote a queued reservation to active in the same instruction (`rental_close` Path B). When `false`, the queued accounts are left off so the close takes Path A — the rental ends and the slot stays empty.\n\nSet this `false` when the caller intends to close the contract next: activating the challenger would leave a brand-new live rental in the way.",
        "optional": true,
        "examples": [],
        "defaultValue": "```ts\ntrue\n```"
      },
      {
        "name": "computeUnits",
        "type": "number",
        "typeKind": "number",
        "description": "Sets compute units to allocate for the transaction.",
        "optional": true,
        "examples": [
          "```ts\n400000\n```"
        ]
      },
      {
        "name": "snapshot",
        "type": "ContractSnapshot",
        "typeKind": "unknown",
        "description": "Optional pre-fetched `ContractSnapshot`. When supplied, skips the aggregated RPC fetch. If the snapshot is stale (contract pointer set but rental account null), the SDK lazy-refetches once and throws if still inconsistent.",
        "optional": true,
        "examples": []
      }
    ]
  },
  {
    "name": "deleteRental",
    "paramsType": "DeleteRentalParams",
    "group": "rental",
    "isAdmin": true,
    "description": "Admin escape hatch to delete a corrupted RentalState (used during schema migrations). Returns rent to the borrower; follow with `releaseRental` to free the fleet.",
    "params": [
      {
        "name": "admin",
        "type": "UniversalSigner",
        "typeKind": "signer",
        "description": "Admin authority (must be config.admin) Accepts string address, web3.js Keypair, or @solana/kit signer",
        "optional": false,
        "examples": []
      },
      {
        "name": "borrower",
        "type": "string | Address",
        "typeKind": "address",
        "description": "Borrower wallet address who will receive the lamport refund. Optional — defaults to system program ID for reset rental slots with no borrower.",
        "optional": true,
        "examples": []
      },
      {
        "name": "rentalState",
        "type": "string | Address",
        "typeKind": "address",
        "description": "Rental state address to delete This is the corrupted rental account that cannot be deserialized",
        "optional": false,
        "examples": []
      },
      {
        "name": "computeUnits",
        "type": "number",
        "typeKind": "number",
        "description": "Sets compute units to allocate for the transaction.",
        "optional": true,
        "examples": [
          "```ts\n100000\n```"
        ]
      }
    ],
    "resultAccount": {
      "accountIndex": 3,
      "keysCount": 4
    }
  },
  {
    "name": "invalidateRental",
    "paramsType": "InvalidateRentalParams",
    "group": "rental",
    "isAdmin": false,
    "description": "Emergency clear of a fleet's SAGE rental flag when no SRSLY contract exists. Use `releaseRental` instead when a contract still exists.",
    "params": [
      {
        "name": "signer",
        "type": "UniversalSigner",
        "typeKind": "signer",
        "description": "Signer paying for transaction fees Accepts string address, web3.js Keypair, or @solana/kit signer",
        "optional": false,
        "examples": []
      },
      {
        "name": "fleet",
        "type": "string | Address",
        "typeKind": "address",
        "description": "Fleet address to invalidate rental status for",
        "optional": false,
        "examples": []
      },
      {
        "name": "ownerProfile",
        "type": "string | Address",
        "typeKind": "address",
        "description": "Fleet owner's profile address (NOT borrower's) Optional — auto-fetched from fleet account when omitted",
        "optional": true,
        "examples": []
      },
      {
        "name": "faction",
        "type": "string | number",
        "typeKind": "address",
        "description": "Owner's faction for starbase derivation Can be faction name ('mud', 'oni', 'ustur') or ID (1, 2, 3) Optional — auto-fetched from fleet account when omitted",
        "optional": true,
        "examples": []
      },
      {
        "name": "computeUnits",
        "type": "number",
        "typeKind": "number",
        "description": "Sets compute units to allocate for the transaction.",
        "optional": true,
        "examples": [
          "```ts\n200000\n```"
        ]
      }
    ]
  },
  {
    "name": "releaseRental",
    "paramsType": "ReleaseRentalParams",
    "group": "rental",
    "isAdmin": false,
    "description": "Free a fleet from SRSLY's rental hold once the rental has been closed. Use `invalidateRental` instead when no contract exists.",
    "params": [
      {
        "name": "signer",
        "type": "UniversalSigner",
        "typeKind": "signer",
        "description": "Signer paying for transaction fees Accepts string address, web3.js Keypair, or @solana/kit signer",
        "optional": false,
        "examples": []
      },
      {
        "name": "fleet",
        "type": "string | Address",
        "typeKind": "address",
        "description": "Fleet address to release from rental control",
        "optional": false,
        "examples": []
      },
      {
        "name": "ownerProfile",
        "type": "string | Address",
        "typeKind": "address",
        "description": "Fleet owner's profile address (NOT borrower's) Optional — auto-fetched from fleet account when omitted",
        "optional": true,
        "examples": []
      },
      {
        "name": "faction",
        "type": "string | number",
        "typeKind": "address",
        "description": "Owner's faction for starbase derivation Can be faction name ('mud', 'oni', 'ustur') or ID (1, 2, 3) Optional — auto-fetched from fleet account when omitted",
        "optional": true,
        "examples": []
      },
      {
        "name": "computeUnits",
        "type": "number",
        "typeKind": "number",
        "description": "Sets compute units to allocate for the transaction.",
        "optional": true,
        "examples": [
          "```ts\n200000\n```"
        ]
      }
    ]
  },
  {
    "name": "reserveRental",
    "paramsType": "ReserveRentalParams",
    "group": "rental",
    "isAdmin": false,
    "description": "Bid on a contract via the GBM-style reservation auction. The winner gets an exclusive window to accept once the current rental ends.",
    "params": [
      {
        "name": "challenger",
        "type": "UniversalSigner",
        "typeKind": "signer",
        "description": "Challenger who is reserving the contract Accepts string address, web3.js Keypair, or @solana/kit signer",
        "optional": false,
        "examples": []
      },
      {
        "name": "challengerProfile",
        "type": "string | Address",
        "typeKind": "address",
        "description": "Challenger's SAGE profile address (required — challenger isn't on fleet yet)",
        "optional": false,
        "examples": []
      },
      {
        "name": "contract",
        "type": "string | Address",
        "typeKind": "address",
        "description": "Rental contract address to reserve",
        "optional": false,
        "examples": []
      },
      {
        "name": "bidPoints",
        "type": "PointsParam",
        "typeKind": "unknown",
        "description": "Points bid for reservation (burned from capture_points). Mutually exclusive with bidAtlas — set one to 0.\n\nPoints are stored on-chain in 8-decimal dust (1 human point = 100_000_000 dust). Bare numbers are interpreted as dust; pass `{ points: N }` for the human-readable form.",
        "optional": true,
        "examples": [
          "```ts\n{ points: 1 }       // 1 human point (100_000_000 dust on-chain)\n```",
          "```ts\n{ dust: 100_000_000 } // explicit dust (same as above)\n```",
          "```ts\n100_000_000         // bare = dust\n```"
        ]
      },
      {
        "name": "bidAtlas",
        "type": "AmountParam",
        "typeKind": "amount",
        "description": "ATLAS premium bid for reservation (in stardust, transferred to contract). Mutually exclusive with bidPoints — set one to 0.",
        "optional": true,
        "examples": [
          "```ts\n{ atlas: 5 } // 5 ATLAS premium\n```",
          "```ts\n{ stardust: 500_000_000 } // 5 ATLAS in stardust\n```"
        ]
      },
      {
        "name": "duration",
        "type": "DurationParam",
        "typeKind": "duration",
        "description": "Requested rental duration for when the reservation activates",
        "optional": false,
        "examples": [
          "```ts\n{ hours: 12 } // 12 hours\n```",
          "```ts\n{ days: 7 } // 7 days\n```"
        ]
      },
      {
        "name": "referrer",
        "type": "string | Address",
        "typeKind": "address",
        "description": "Affiliate member state address (optional) If provided, the affiliate receives a portion of fees",
        "optional": true,
        "examples": []
      },
      {
        "name": "rate",
        "type": "AmountParam",
        "typeKind": "amount",
        "description": "Expected rental rate (optional client-side safety check).\n\nMirrors `acceptRental`. If provided, the SDK compares this against the on-chain contract rate and throws before building the transaction if they don't match. Reserve locks escrow at the current rate, so this guards the same display-vs-submit drift the accept path does.\n\nAccepts a plain number / bigint (stardust), `{ atlas: number }`, or `{ stardust: number | bigint }`.",
        "optional": true,
        "examples": [
          "```ts\n{ atlas: 1 } // 1 ATLAS per period\n```",
          "```ts\n{ stardust: 500_000_000 } // 5 ATLAS in stardust (smallest unit)\n```"
        ]
      },
      {
        "name": "discountAuth",
        "type": "SerializedDiscountAuth",
        "typeKind": "unknown",
        "description": "Discount authorization from createDiscount() — pass directly from API response. No deserialization needed.\n\nMirrors `acceptRental`: the discount is verified and locked at reserve time (the same moment escrow is locked) and settled at close. Requires a valid `referrer` (the affiliate member the discount was signed for); a missing or stale referrer degrades to no discount instead of failing the reservation.",
        "optional": true,
        "examples": []
      },
      {
        "name": "autoMinBid",
        "type": "boolean",
        "typeKind": "boolean",
        "description": "When true (default) and neither `bidAtlas` nor `bidPoints` is set, the wrapper fetches the contract's current minimum bid via `getMinimumBid` and submits exactly that as `bidAtlas`. Set to `false` to opt out — the instruction will then go through with bid = 0 and the program will reject if a defender already exists.",
        "optional": true,
        "examples": []
      },
      {
        "name": "computeUnits",
        "type": "number",
        "typeKind": "number",
        "description": "Compute units to allocate for the transaction.\n\nreserveRental issues several CPIs (token transfers, optional SLYvault discount verify, antegen fiber rebuild, and on a contest the defender refund), so the 200k default budget can run out. Required with a 200,000 floor — mirrors `acceptRental` (which floors higher at 400k because it also drives the SAGE rental_open CPI).",
        "optional": false,
        "examples": [
          "```ts\n200000\n```"
        ]
      },
      {
        "name": "snapshot",
        "type": "ContractSnapshot",
        "typeKind": "unknown",
        "description": "Optional pre-fetched `ContractSnapshot`. When supplied, skips the aggregated RPC fetch. If the snapshot is stale (contract pointer set but rental account null), the SDK lazy-refetches once and throws if still inconsistent.",
        "optional": true,
        "examples": []
      }
    ],
    "resultAccount": {
      "accountIndex": 10,
      "keysCount": 21
    }
  }
];

export const INSTRUCTIONS_BY_NAME: Record<string, Instruction> = Object.fromEntries(
  INSTRUCTIONS.map((ix) => [ix.name, ix])
);

export const FETCHES: FetchEntry[] = [
  {
    "name": "fetchBorrower",
    "acct": "borrower",
    "group": "borrower",
    "description": "Fetch borrower state from the SRSLY program\n\nAccepts either a borrower state PDA address OR a wallet address. If direct fetch fails, automatically derives the borrower state PDA from the address (treating it as a wallet) and retries.",
    "schema": [
      {
        "name": "version",
        "type": "u32",
        "docs": "Account version for future migrations"
      },
      {
        "name": "bump",
        "type": "u8",
        "docs": "PDA bump seed"
      },
      {
        "name": "authority",
        "type": "pubkey",
        "docs": "Authority's wallet address (the borrower)"
      },
      {
        "name": "activeRentals",
        "type": "vec<pubkey>",
        "docs": "Currently tracked fleet rentals for point accumulation (max 10) NOTE: This is a limited tracker - see active_rental_count for true total"
      },
      {
        "name": "activeRentalCount",
        "type": "u16",
        "docs": "Total count of active rentals (true accounting, not limited by vec capacity) This ensures we track the real number even if active_rentals vec is full"
      },
      {
        "name": "capturePoints",
        "type": "u64",
        "docs": "Current capture points accumulated"
      },
      {
        "name": "managedTokenAccount",
        "type": "pubkey",
        "docs": "Managed token account for receiving ATLAS refunds from reservations Created via init_if_needed in rental_reserve"
      },
      {
        "name": "createdAt",
        "type": "i64",
        "docs": "Timestamp when borrower state was created"
      },
      {
        "name": "updatedAt",
        "type": "i64",
        "docs": "Timestamp when borrower state was last updated"
      }
    ]
  },
  {
    "name": "fetchBorrowerBalance",
    "acct": "borrowerBalance",
    "group": "borrower",
    "description": "Fetch a borrower's claimable ATLAS balance.\n\nResolves the BorrowerState, then reads the SPL balance of its managed ATA — the accumulated reservation bid refunds and knockoff bonuses that claimBorrower sweeps into the borrower's wallet.\n\nAn uninitialized borrower is not an error: it reads as a zero balance with `initialized: false`, so a caller can render the same view before and after `createBorrower`. The managed ATA always exists once the state does (`borrower_create` creates it), so `initialized` is the only gate."
  },
  {
    "name": "fetchChainNowSeconds",
    "acct": "chainNowSeconds",
    "group": "other",
    "description": "Fetch the cluster's `Clock::unix_timestamp` as a JS `number` (seconds).\n\nOne RPC round-trip (`getAccountInfo` on the sysvar). Safe to call in parallel with other fetches."
  },
  {
    "name": "fetchConfig",
    "acct": "config",
    "group": "config",
    "description": "Fetch global config state from the SRSLY program",
    "schema": [
      {
        "name": "version",
        "type": "u32",
        "docs": "Account version for future migrations"
      },
      {
        "name": "bump",
        "type": "u8",
        "docs": "PDA bump seed"
      },
      {
        "name": "admin",
        "type": "pubkey",
        "docs": "Authority that can update configuration (admin)"
      },
      {
        "name": "stardustToAtlas",
        "type": "u64",
        "docs": "Stardust to ATLAS conversion rate (default: 100M = 1 ATLAS)"
      },
      {
        "name": "serviceFeeBps",
        "type": "u64",
        "docs": "Service fee in basis points (default: 1000 = 10%, max: 10%)"
      },
      {
        "name": "baseBps",
        "type": "u16",
        "docs": "Basis points denominator (default: 10,000)"
      },
      {
        "name": "rentalDurationMinSeconds",
        "type": "i64",
        "docs": "Minimum rental duration (default: 3600s = 1 hour)"
      },
      {
        "name": "rentalDurationMaxSeconds",
        "type": "i64",
        "docs": "Maximum rental duration (default: 8,035,200s ≈ 3 months)"
      },
      {
        "name": "atlasMint",
        "type": "pubkey",
        "docs": "ATLAS token mint for payments"
      },
      {
        "name": "slyvault",
        "type": "pubkey",
        "docs": "slyvault vault pubkey for fee distribution"
      },
      {
        "name": "reservationsEnabled",
        "type": "bool",
        "docs": "Whether reservation system is enabled"
      },
      {
        "name": "pointsPerDay",
        "type": "u64",
        "docs": "Points awarded per day of rental"
      },
      {
        "name": "maxCapturePoints",
        "type": "u64",
        "docs": "Ceiling on `BorrowerState::capture_points`. A borrower at or above it earns nothing until spending drops them below — see the freeze in `remove_active_rental`.  Must exceed the largest award a single rental can produce (`rental_duration_max_seconds / 86400 × points_per_day`), or bidding the maximum wins a rental that mints the maximum straight back and the bid pays for itself. Enforced in `validate`.  Reuses v3's `cancellation_penalty` slot — same type, same offset, so a v3 account needs no realloc. `config_migrate` overwrites the inherited value, which as a cap would be far too small to be survivable."
      },
      {
        "name": "minCaptureThreshold",
        "type": "u64",
        "docs": "Minimum points to capture any flag"
      },
      {
        "name": "reservationCooldownSeconds",
        "type": "u32",
        "docs": "Seconds a queued reservation is protected from being displaced by a points bid. ATLAS bids are never gated: they compensate the defender out of the challenger's own bid, whereas a points knockoff pays them nothing (bonus is structurally 0 in points-vs-points). 0 disables the gate.  Reuses v3's `weight_base` slot — same type, same offset."
      },
      {
        "name": "Reserved",
        "type": "[u8; 5]",
        "docs": "Free space left by v3's `weight_multiplier: f32` + `max_weight: u8`, retired when `popularity` stopped needing tuning dials. Kept as padding so the account size is unchanged from v3 and no realloc is required."
      },
      {
        "name": "captureRateBps",
        "type": "u64",
        "docs": "Rate increase in basis points (min 10000 = 100%, default: 10500 = 105%)"
      },
      {
        "name": "atlasPerPoint",
        "type": "u64",
        "docs": "Stardust-of-ATLAS per stardust-of-points. With both in 8-decimal precision (1 ATLAS = 100M stardust, 1 point = 100M dust), this acts as the \"ATLAS per point\" ratio in human terms. Default 100 = 100 ATLAS per point."
      },
      {
        "name": "contestedMultiplierMaxBps",
        "type": "u16",
        "docs": "Maximum floor multiplier in basis points (100 = 1×, 465 = 4.65×). Linear ramp from 1× (defender just reserved) to this value (snipe at activation). 100 disables the ramp. Default 465. Range 100..=10000."
      },
      {
        "name": "rentalsCompleted",
        "type": "u64",
        "docs": "Lifetime count of rentals that ran their full term and closed normally via `process_rental_close`. Does NOT include cancellations (those keep status = Cancelled on the rental account). Monotonic. Not exposed in ConfigUpdateParams — admin can't tamper."
      },
      {
        "name": "lookupTable",
        "type": "pubkey",
        "docs": "Address Lookup Table for transaction size optimization Contains static addresses used across all rental operations"
      },
      {
        "name": "createdAt",
        "type": "i64",
        "docs": "Timestamp when config was created"
      },
      {
        "name": "updatedAt",
        "type": "i64",
        "docs": "Timestamp when config was last updated"
      },
      {
        "name": "staleDiscountPerDayBps",
        "type": "u16",
        "docs": "Daily stale-discount in bps (e.g. 200 = 2%/day off the stored rate per stale day). 0 disables the mechanic protocol-wide. The per-second rate is derived inline at `rental_accept` writeback time via `× stale_seconds / 86_400` so the discount tracks stale time at the same resolution the rest of the program prorates rentals (seconds)."
      },
      {
        "name": "bonusMultiplierBps",
        "type": "u16",
        "docs": "Multiplier applied to the same-currency knockoff bonus in `rental_reserve`. Custom scale: 100 = 1× (the pre-v3 formula, a no-op), 10_000 = 100×. The bonus is still clamped to the bid diff (`basis`) after scaling, so the contract stays solvent for any value; the dial only controls how quickly closeness × multiplier saturates that cap. Default 100. Range 100..=10_000. Migrated configs that predate this field MUST be written to 100 (not the realloc-zero 0, which would mean 0× = bonuses disabled)."
      }
    ]
  },
  {
    "name": "fetchContract",
    "acct": "contract",
    "group": "contract",
    "description": "Fetch contract state from the SRSLY program",
    "schema": [
      {
        "name": "version",
        "type": "u32",
        "docs": "Account version for future migrations"
      },
      {
        "name": "bump",
        "type": "u8",
        "docs": "PDA bump seed"
      },
      {
        "name": "toClose",
        "type": "bool",
        "docs": "Whether contract is flagged for closure (owner wants to close but rental active)"
      },
      {
        "name": "rate",
        "type": "u64",
        "docs": "Rental rate per day in Stardust (100M Stardust = 1 ATLAS)"
      },
      {
        "name": "durationMinSeconds",
        "type": "i64",
        "docs": "Minimum rental duration in seconds"
      },
      {
        "name": "durationMaxSeconds",
        "type": "i64",
        "docs": "Maximum rental duration in seconds"
      },
      {
        "name": "cancelDelayMin",
        "type": "i64",
        "docs": "Minimum cancellation delay in seconds (0 = instant cancel allowed) Default: 0 (instant cancels allowed by default)"
      },
      {
        "name": "popularity",
        "type": "u8",
        "docs": "How contested this fleet has been lately, on a 1..=5 scale.  Display only — nothing prices off this. It ratchets up as reservations arrive and decays as the fleet sits idle, so it is path-dependent: two contracts with identical terms and identical rental histories can hold different values depending on the order things happened in. Anything that starts reading it for economics inherits that, which is why it stopped scaling CTF awards.  `ContractStateV1` still calls this field `weight` — that name describes what v1 accounts hold, back when it multiplied point awards."
      },
      {
        "name": "reservationsDisabled",
        "type": "bool",
        "docs": "Whether reservations are disabled for this contract (owner opt-out) Default: false (reservations allowed)"
      },
      {
        "name": "owner",
        "type": "pubkey",
        "docs": "Fleet owner who receives payments"
      },
      {
        "name": "fleet",
        "type": "pubkey",
        "docs": "Fleet associated with this contract"
      },
      {
        "name": "gameId",
        "type": "pubkey",
        "docs": "Game ID for SAGE integration"
      },
      {
        "name": "ownerProfile",
        "type": "pubkey",
        "docs": "Owner's Star Atlas game profile"
      },
      {
        "name": "activeRental",
        "type": "pubkey",
        "docs": "Active rental PDA address (system_program::ID = empty)"
      },
      {
        "name": "queuedRental",
        "type": "pubkey",
        "docs": "Queued rental PDA address (system_program::ID = empty)"
      },
      {
        "name": "delegate",
        "type": "option<pubkey>",
        "docs": "Delegated address that can update rate on behalf of owner Default: None (only owner can update rate)"
      },
      {
        "name": "thread",
        "type": "pubkey",
        "docs": "Per-contract automation thread (system_program::ID = no thread)"
      },
      {
        "name": "trigger",
        "type": "Trigger",
        "docs": "Default trigger for thread settlement"
      },
      {
        "name": "managedTokenAccount",
        "type": "pubkey",
        "docs": "Contract's managed token account (ATA of contract PDA)"
      },
      {
        "name": "totalEarned",
        "type": "u64",
        "docs": "Per-contract ATLAS earned (lifetime total)"
      },
      {
        "name": "ownerClaimable",
        "type": "u64",
        "docs": "Accumulated ATLAS earned by owner, not yet claimed"
      },
      {
        "name": "feeClaimable",
        "type": "u64",
        "docs": "Accumulated service fees, not yet paid to slyvault (flushed at rental_close)"
      },
      {
        "name": "contestedThreshold",
        "type": "u8",
        "docs": "Owner-configured number of contests required before the next activation increases `rate` by `capture_rate_bps`. 0 disables capture-rate entirely (rate never auto-increments). 1..=10 enables it. Default 1."
      },
      {
        "name": "contestedCount",
        "type": "u8",
        "docs": "Contests accumulated since the last rate increase. Resets on increase and when a rental cycle completes without an activation."
      },
      {
        "name": "createdAt",
        "type": "i64",
        "docs": "Timestamp when contract was created"
      },
      {
        "name": "updatedAt",
        "type": "i64",
        "docs": "Timestamp when contract was last updated"
      },
      {
        "name": "staleDiscountMaxBps",
        "type": "u16",
        "docs": "Per-contract cap on the stale-discount writeback (bps). 0      → mechanic disabled for this contract (rate never decays). 5_000  → up to 50% discount; rate floored at 50% of its stored value. 10_000 → no per-contract cap; the writeback still clamps at the program-wide minimum rate (`config.stardust_to_atlas`). Owner-settable at `contract_create` + `contract_update`. Default 0 — opt-in only."
      },
      {
        "name": "staleSince",
        "type": "i64",
        "docs": "Unix-seconds anchor for the stale-discount decay. Stamped at `contract_create` (init time) and re-stamped inside `process_rental_close` whenever `active_rental` clears to `system_program::ID`. Cleared to 0 inside `rental_accept` once the decay branch fires (sentinel: \"rate already decayed for this stale window, don't re-decay\"). When 0, no decay applies regardless of elapsed time."
      }
    ]
  },
  {
    "name": "fetchFiber",
    "acct": "fiber",
    "group": "contract",
    "description": "Fetch and decode a FiberState by contract address and fiber index.\n\nLooks up the contract's thread, derives the fiber PDA, then fetches + decodes."
  },
  {
    "name": "fetchFiberByAddress",
    "acct": "fiberByAddress",
    "group": "contract",
    "description": "Fetch and decode a FiberState account by its direct address."
  },
  {
    "name": "fetchFleet",
    "acct": "fleet",
    "group": "contract",
    "description": "Fetch fleet state from the Star Atlas SAGE program"
  },
  {
    "name": "fetchLookupTable",
    "acct": "lookupTable",
    "group": "other",
    "description": "Fetch the SRSLY Address Lookup Table from chain\n\nThe ALT contains static addresses used across all rental operations, reducing transaction size by ~310 bytes when used with versioned transactions."
  },
  {
    "name": "fetchMember",
    "acct": "member",
    "group": "affiliate",
    "description": "Fetch member state from the SLYvault program"
  },
  {
    "name": "fetchRental",
    "acct": "rental",
    "group": "rental",
    "description": "Fetch rental state from the SRSLY program",
    "schema": [
      {
        "name": "version",
        "type": "u32",
        "docs": "Account version for future migrations"
      },
      {
        "name": "bump",
        "type": "u8",
        "docs": "PDA bump seed"
      },
      {
        "name": "borrower",
        "type": "pubkey",
        "docs": "Borrower public key (receives refunds if cancelled)"
      },
      {
        "name": "borrowerState",
        "type": "pubkey",
        "docs": "BorrowerState PDA for this rental (single source of borrower info)"
      },
      {
        "name": "borrowerProfile",
        "type": "pubkey",
        "docs": "Borrower's SAGE profile (stored for frontend convenience)"
      },
      {
        "name": "contract",
        "type": "pubkey",
        "docs": "Reference to the rental contract"
      },
      {
        "name": "rate",
        "type": "u64",
        "docs": "Gross rate per day in Stardust (= contract.rate at accept/reserve time)"
      },
      {
        "name": "lastPayment",
        "type": "i64",
        "docs": "Timestamp of last pro-rata payment settlement (base for next calculation)"
      },
      {
        "name": "escrow",
        "type": "u64",
        "docs": "ATLAS deposited as escrow for this rental (in stardust)"
      },
      {
        "name": "startTime",
        "type": "i64",
        "docs": "Rental start timestamp"
      },
      {
        "name": "endTime",
        "type": "i64",
        "docs": "Rental end timestamp"
      },
      {
        "name": "serviceFee",
        "type": "u64",
        "docs": "Total fee target for post-rental collection (total * fee_bps / base_bps)"
      },
      {
        "name": "feeBps",
        "type": "u16",
        "docs": "Fee basis points snapshotted from config (for cancel proration)"
      },
      {
        "name": "referrer",
        "type": "option<pubkey>",
        "docs": "Referrer affiliate member for deferred fee tracking"
      },
      {
        "name": "discountBps",
        "type": "u16",
        "docs": "Discount basis points verified at accept time (0 = no discount)"
      },
      {
        "name": "bidPoints",
        "type": "u64",
        "docs": "Points bid for reservation contest comparison (0 if ATLAS bid)"
      },
      {
        "name": "bidAtlas",
        "type": "u64",
        "docs": "ATLAS premium bid for reservation contest (0 if points bid)"
      },
      {
        "name": "cancelDelayMin",
        "type": "i64",
        "docs": "Minimum cancellation delay in seconds, snapshotted from `contract.cancel_delay_min` at accept/reserve time. Locks the borrower's worst-case notice period — owner raising the contract value mid-rental cannot tighten this. Owner lowering the contract value flows through (cancel uses the lesser of the two)."
      },
      {
        "name": "status",
        "type": "RentalStatus",
        "docs": "Rental lifecycle status (Available, Queued, Active)"
      },
      {
        "name": "updatedAt",
        "type": "i64",
        "docs": "Timestamp when rental was last updated (used as base for next pro-rata payment)"
      },
      {
        "name": "createdAt",
        "type": "i64",
        "docs": "Timestamp when rental was created"
      }
    ]
  },
  {
    "name": "fetchThread",
    "acct": "thread",
    "group": "contract",
    "description": "Fetch and decode an Antegen thread account by contract address.\n\nLooks up the contract's `thread` field, then fetches and decodes the thread account. Returns null if no thread is configured on the contract."
  },
  {
    "name": "fetchThreadByAddress",
    "acct": "threadByAddress",
    "group": "contract",
    "description": "Fetch and decode a raw Antegen thread account by its direct address.\n\nUsed internally by instruction wrappers that already know the thread address."
  },
  {
    "name": "fetchThreadByAddressOrNull",
    "acct": "threadByAddressOrNull",
    "group": "other",
    "description": "Like fetchThreadByAddress, but returns null when the account does not exist instead of throwing.\n\n`contract.thread` can outlive the account it names — `deleteContractThread` tears a thread down without clearing the pointer — so a caller often needs to tell \"gone\" from \"unreadable\". Catching the throwing variant would conflate the two and turn a transport failure into a decision."
  },
  {
    "name": "fetchTokenBalance",
    "acct": "tokenBalance",
    "group": "other",
    "description": "Fetch an SPL token account's balance.\n\nA missing or closed account is not an error — it reads as a zero balance with `exists: false`, which is what a caller deciding whether to show a claim button actually needs."
  },
  {
    "name": "fetchVault",
    "acct": "vault",
    "group": "vault",
    "description": "Fetch vault state from the SLYvault program"
  }
];

export const FETCHES_BY_NAME: Record<string, FetchEntry> = Object.fromEntries(
  FETCHES.map((f) => [f.name, f])
);

export const EVENTS: EventEntry[] = [
  {
    "name": "CapturePointsChanged",
    "group": "borrower",
    "verb": "capturePointsChanged",
    "description": "Emitted on every write to `capture_points`.\n\n`balance` is the point of this event: it is an absolute checkpoint, so a\nconsumer can verify it saw every movement (`balance == previous + delta`)\nrather than silently reporting a wrong total after missing one. Reconstructing\na balance by summing deltas across the lifecycle events instead would be\ncorrect only while nothing is ever dropped, and offers no way to notice when\nsomething is.\n\nEvery mutation of `capture_points` lives in `BorrowerStateAccount`, and each\none emits this — keep it that way, or the invariant above stops holding.",
    "schema": [
      {
        "name": "borrowerState",
        "type": "pubkey",
        "docs": ""
      },
      {
        "name": "borrower",
        "type": "pubkey",
        "docs": ""
      },
      {
        "name": "delta",
        "type": "i64",
        "docs": "Signed movement. Negative for bids and cancellation clawbacks."
      },
      {
        "name": "balance",
        "type": "u64",
        "docs": "Balance after the movement."
      },
      {
        "name": "reason",
        "type": "PointsReason",
        "docs": ""
      }
    ]
  },
  {
    "name": "BorrowerClaimed",
    "group": "borrower",
    "verb": "claimed",
    "description": "Emitted when the borrower's managed token account drains to their wallet.",
    "schema": [
      {
        "name": "borrowerState",
        "type": "pubkey",
        "docs": ""
      },
      {
        "name": "borrower",
        "type": "pubkey",
        "docs": ""
      },
      {
        "name": "amount",
        "type": "u64",
        "docs": ""
      }
    ]
  },
  {
    "name": "BorrowerClosed",
    "group": "borrower",
    "verb": "closed",
    "description": "Emitted when a borrower closes their state PDA + managed token account.",
    "schema": [
      {
        "name": "borrowerState",
        "type": "pubkey",
        "docs": ""
      },
      {
        "name": "borrower",
        "type": "pubkey",
        "docs": ""
      }
    ]
  },
  {
    "name": "BorrowerCreated",
    "group": "borrower",
    "verb": "created",
    "description": "Emitted when a borrower opens their state PDA + managed token account.",
    "schema": [
      {
        "name": "borrowerState",
        "type": "pubkey",
        "docs": ""
      },
      {
        "name": "borrower",
        "type": "pubkey",
        "docs": ""
      }
    ]
  },
  {
    "name": "ContractClosed",
    "group": "contract",
    "verb": "closed",
    "description": "Emitted when `contract_close` actually closes the contract account.",
    "schema": [
      {
        "name": "contract",
        "type": "pubkey",
        "docs": ""
      },
      {
        "name": "owner",
        "type": "pubkey",
        "docs": ""
      }
    ]
  },
  {
    "name": "ContractCloseQueued",
    "group": "contract",
    "verb": "closeQueued",
    "description": "Emitted when `contract_close` sets `to_close = true` because a live\nactive rental is blocking immediate closure. The contract will close\nautomatically when that rental ends.",
    "schema": [
      {
        "name": "contract",
        "type": "pubkey",
        "docs": ""
      },
      {
        "name": "owner",
        "type": "pubkey",
        "docs": ""
      }
    ]
  },
  {
    "name": "ContractCreated",
    "group": "contract",
    "verb": "created",
    "description": "Emitted when a contract is created (fleet listed for rental).",
    "schema": [
      {
        "name": "contract",
        "type": "pubkey",
        "docs": ""
      },
      {
        "name": "owner",
        "type": "pubkey",
        "docs": ""
      },
      {
        "name": "fleet",
        "type": "pubkey",
        "docs": ""
      },
      {
        "name": "gameId",
        "type": "pubkey",
        "docs": ""
      },
      {
        "name": "rate",
        "type": "u64",
        "docs": ""
      },
      {
        "name": "durationMinSeconds",
        "type": "i64",
        "docs": ""
      },
      {
        "name": "durationMaxSeconds",
        "type": "i64",
        "docs": ""
      },
      {
        "name": "cancelDelayMin",
        "type": "i64",
        "docs": ""
      },
      {
        "name": "reservationsDisabled",
        "type": "bool",
        "docs": ""
      },
      {
        "name": "contestedThreshold",
        "type": "u8",
        "docs": ""
      },
      {
        "name": "staleDiscountMaxBps",
        "type": "u16",
        "docs": ""
      }
    ]
  },
  {
    "name": "DelegateSet",
    "group": "contract",
    "verb": "delegateSet",
    "description": "Emitted when the contract owner sets or clears the delegate.",
    "schema": [
      {
        "name": "contract",
        "type": "pubkey",
        "docs": ""
      },
      {
        "name": "owner",
        "type": "pubkey",
        "docs": ""
      },
      {
        "name": "delegate",
        "type": "option<pubkey>",
        "docs": ""
      }
    ]
  },
  {
    "name": "ContractFiberDoctored",
    "group": "contract",
    "verb": "fiberDoctored",
    "description": "Emitted on `contract_doctor_fiber` — one per fiber rewritten to bring a\nthread's `fiber_ids` back into agreement with the accounts they name.",
    "schema": [
      {
        "name": "thread",
        "type": "pubkey",
        "docs": ""
      },
      {
        "name": "fiber",
        "type": "pubkey",
        "docs": ""
      },
      {
        "name": "fiberIndex",
        "type": "u8",
        "docs": ""
      }
    ]
  },
  {
    "name": "StaleDecayApplied",
    "group": "contract",
    "verb": "staleDecayApplied",
    "description": "Emitted on the stale branch of `rental_accept` when the stale-discount\nwriteback actually moves the stored `rate`. Mutually exclusive with\nthe contested bump (the demand branch). `stale_seconds` is the gap\nbetween the previous close and this accept — what the borrower's\ndiscount is computed against.",
    "schema": [
      {
        "name": "contract",
        "type": "pubkey",
        "docs": ""
      },
      {
        "name": "oldRate",
        "type": "u64",
        "docs": ""
      },
      {
        "name": "newRate",
        "type": "u64",
        "docs": ""
      },
      {
        "name": "staleSeconds",
        "type": "u64",
        "docs": ""
      }
    ]
  },
  {
    "name": "ContractUpdated",
    "group": "contract",
    "verb": "updated",
    "description": "Emitted after `contract_update` applies term changes.\nCarries the post-update values so indexers don't need to diff state.",
    "schema": [
      {
        "name": "contract",
        "type": "pubkey",
        "docs": ""
      },
      {
        "name": "owner",
        "type": "pubkey",
        "docs": ""
      },
      {
        "name": "rate",
        "type": "u64",
        "docs": ""
      },
      {
        "name": "durationMinSeconds",
        "type": "i64",
        "docs": ""
      },
      {
        "name": "durationMaxSeconds",
        "type": "i64",
        "docs": ""
      },
      {
        "name": "cancelDelayMin",
        "type": "i64",
        "docs": ""
      },
      {
        "name": "reservationsDisabled",
        "type": "bool",
        "docs": ""
      }
    ]
  },
  {
    "name": "FeesPaid",
    "group": "fees",
    "verb": "paid",
    "description": "Emitted when accumulated fees are flushed to slyvault.\nCaptures fee/discount split.",
    "schema": [
      {
        "name": "contract",
        "type": "pubkey",
        "docs": ""
      },
      {
        "name": "feeCollected",
        "type": "u64",
        "docs": ""
      },
      {
        "name": "discount",
        "type": "u64",
        "docs": ""
      },
      {
        "name": "discountBps",
        "type": "u16",
        "docs": ""
      }
    ]
  },
  {
    "name": "OwnerPaid",
    "group": "owner",
    "verb": "paid",
    "description": "Emitted when owner_claimable is transferred to owner's ATA.\nCovers both auto-transfer (contract_process) and manual claim (contract_claim).",
    "schema": [
      {
        "name": "contract",
        "type": "pubkey",
        "docs": ""
      },
      {
        "name": "owner",
        "type": "pubkey",
        "docs": ""
      },
      {
        "name": "amount",
        "type": "u64",
        "docs": ""
      }
    ]
  },
  {
    "name": "RentalAccepted",
    "group": "rental",
    "verb": "accepted",
    "description": "Emitted when a rental is accepted (direct or from reservation).\nCaptures all inputs needed to verify settlement math.",
    "schema": [
      {
        "name": "rentalState",
        "type": "pubkey",
        "docs": ""
      },
      {
        "name": "contract",
        "type": "pubkey",
        "docs": ""
      },
      {
        "name": "borrower",
        "type": "pubkey",
        "docs": ""
      },
      {
        "name": "escrow",
        "type": "u64",
        "docs": ""
      },
      {
        "name": "rate",
        "type": "u64",
        "docs": ""
      },
      {
        "name": "serviceFee",
        "type": "u64",
        "docs": ""
      },
      {
        "name": "feeBps",
        "type": "u16",
        "docs": ""
      },
      {
        "name": "startTime",
        "type": "i64",
        "docs": ""
      },
      {
        "name": "endTime",
        "type": "i64",
        "docs": ""
      }
    ]
  },
  {
    "name": "RentalCancelled",
    "group": "rental",
    "verb": "cancelled",
    "description": "Emitted when borrower cancels early.\nCaptures the three-way split: owner / fee / refund.",
    "schema": [
      {
        "name": "rentalState",
        "type": "pubkey",
        "docs": ""
      },
      {
        "name": "contract",
        "type": "pubkey",
        "docs": ""
      },
      {
        "name": "borrower",
        "type": "pubkey",
        "docs": ""
      },
      {
        "name": "ownerEarned",
        "type": "u64",
        "docs": ""
      },
      {
        "name": "feeCollected",
        "type": "u64",
        "docs": ""
      },
      {
        "name": "refund",
        "type": "u64",
        "docs": ""
      },
      {
        "name": "newEndTime",
        "type": "i64",
        "docs": ""
      }
    ]
  },
  {
    "name": "RentalClosed",
    "group": "rental",
    "verb": "closed",
    "description": "Emitted when rental_close finalizes (after expiry or cancel).\nCaptures final escrow reconciliation + CTF points.",
    "schema": [
      {
        "name": "rentalState",
        "type": "pubkey",
        "docs": ""
      },
      {
        "name": "contract",
        "type": "pubkey",
        "docs": ""
      },
      {
        "name": "borrower",
        "type": "pubkey",
        "docs": ""
      },
      {
        "name": "ownerEarned",
        "type": "u64",
        "docs": ""
      },
      {
        "name": "feeCollected",
        "type": "u64",
        "docs": ""
      },
      {
        "name": "pointsAwarded",
        "type": "u64",
        "docs": ""
      }
    ]
  },
  {
    "name": "RentalSettled",
    "group": "rental",
    "verb": "settled",
    "description": "Emitted on each settlement tick (mid-period and final).\nTracks incremental owner earnings and escrow drawdown.",
    "schema": [
      {
        "name": "rentalState",
        "type": "pubkey",
        "docs": ""
      },
      {
        "name": "contract",
        "type": "pubkey",
        "docs": ""
      },
      {
        "name": "ownerEarned",
        "type": "u64",
        "docs": ""
      },
      {
        "name": "escrowRemaining",
        "type": "u64",
        "docs": ""
      },
      {
        "name": "isFinal",
        "type": "bool",
        "docs": ""
      }
    ]
  },
  {
    "name": "ReservationForceClosed",
    "group": "reservation",
    "verb": "forceClosed",
    "description": "Emitted when the owner closes a contract out from under a queued\nreservation. The challenger is made whole on their gross stake —\n`refund` = `from_contract` + `from_owner`, where `from_owner` is the\nshortfall the owner tops up (the bonus already paid out during the\ncontract's auction history). No CTF points are awarded: the rental\nnever happened.",
    "schema": [
      {
        "name": "rentalState",
        "type": "pubkey",
        "docs": ""
      },
      {
        "name": "contract",
        "type": "pubkey",
        "docs": ""
      },
      {
        "name": "borrower",
        "type": "pubkey",
        "docs": ""
      },
      {
        "name": "refund",
        "type": "u64",
        "docs": ""
      },
      {
        "name": "fromContract",
        "type": "u64",
        "docs": ""
      },
      {
        "name": "fromOwner",
        "type": "u64",
        "docs": ""
      }
    ]
  },
  {
    "name": "ReservationKnockedOff",
    "group": "reservation",
    "verb": "knockedOff",
    "description": "Emitted when a challenger displaces an existing queued reservation.",
    "schema": [
      {
        "name": "rentalState",
        "type": "pubkey",
        "docs": ""
      },
      {
        "name": "contract",
        "type": "pubkey",
        "docs": ""
      },
      {
        "name": "displacedBorrower",
        "type": "pubkey",
        "docs": ""
      },
      {
        "name": "refund",
        "type": "u64",
        "docs": ""
      },
      {
        "name": "bonus",
        "type": "u64",
        "docs": ""
      },
      {
        "name": "newBorrower",
        "type": "pubkey",
        "docs": ""
      },
      {
        "name": "newBidAtlas",
        "type": "u64",
        "docs": ""
      },
      {
        "name": "newBidPoints",
        "type": "u64",
        "docs": ""
      }
    ]
  },
  {
    "name": "ReservationPlaced",
    "group": "reservation",
    "verb": "placed",
    "description": "Emitted on first-time reservation (queue was Available).\nThe promotion to active rental is signaled by `RentalAccepted`.",
    "schema": [
      {
        "name": "rentalState",
        "type": "pubkey",
        "docs": ""
      },
      {
        "name": "contract",
        "type": "pubkey",
        "docs": ""
      },
      {
        "name": "borrower",
        "type": "pubkey",
        "docs": ""
      },
      {
        "name": "bidAtlas",
        "type": "u64",
        "docs": ""
      },
      {
        "name": "bidPoints",
        "type": "u64",
        "docs": ""
      },
      {
        "name": "escrow",
        "type": "u64",
        "docs": ""
      }
    ]
  },
  {
    "name": "ThreadClosed",
    "group": "thread",
    "verb": "closed",
    "description": "Emitted when an automation thread is closed.",
    "schema": [
      {
        "name": "contract",
        "type": "pubkey",
        "docs": ""
      },
      {
        "name": "thread",
        "type": "pubkey",
        "docs": ""
      }
    ]
  },
  {
    "name": "ThreadCreated",
    "group": "thread",
    "verb": "created",
    "description": "Emitted when a per-contract automation thread is created.",
    "schema": [
      {
        "name": "contract",
        "type": "pubkey",
        "docs": ""
      },
      {
        "name": "thread",
        "type": "pubkey",
        "docs": ""
      },
      {
        "name": "paymentsFreq",
        "type": "string",
        "docs": ""
      },
      {
        "name": "funding",
        "type": "u64",
        "docs": ""
      }
    ]
  },
  {
    "name": "ThreadFunded",
    "group": "thread",
    "verb": "funded",
    "description": "Emitted on `contract_thread_update` — captures both funding deltas and\noptional schedule changes.",
    "schema": [
      {
        "name": "contract",
        "type": "pubkey",
        "docs": ""
      },
      {
        "name": "thread",
        "type": "pubkey",
        "docs": ""
      },
      {
        "name": "added",
        "type": "u64",
        "docs": ""
      },
      {
        "name": "newPaymentsFreq",
        "type": "option<string>",
        "docs": ""
      }
    ]
  }
];

export const EVENTS_BY_NAME: Record<string, EventEntry> = Object.fromEntries(
  EVENTS.map((e) => [e.name, e])
);

export const QUERIES: Query[] = [
  {
    "name": "estimateBorrowerSetupCost",
    "description": "",
    "returnType": "BorrowerSetupCostQuote",
    "group": "borrower",
    "params": []
  },
  {
    "name": "diagnoseContract",
    "description": "Diagnose one contract.\n\nReads account state only — it never walks transaction history, so it costs two RPC round trips regardless of how long the contract has existed. That is deliberate: reconstructing a fiber's *content* needs history and belongs to `antegen thread doctor`; deciding whether a contract is stuck does not.",
    "returnType": "ContractDiagnosis",
    "group": "contract",
    "params": []
  },
  {
    "name": "estimateOwnerSetupCost",
    "description": "",
    "returnType": "OwnerSetupCostQuote",
    "group": "contract",
    "params": [
      {
        "name": "executionBudget",
        "type": "SolParam",
        "typeKind": "unknown",
        "description": "Execution budget preloaded into the thread on top of `MINIMUM_THREAD_FUNDING`. Defaults to `DEFAULT_EXECUTION_BUDGET` (~1 year daily cron).",
        "optional": true,
        "examples": []
      },
      {
        "name": "ownerAtaExists",
        "type": "boolean",
        "typeKind": "boolean",
        "description": "Skip the 0.00204 SOL owner-ATA rent if the owner already has an ATLAS ATA. Defaults to `false` (charge it).",
        "optional": true,
        "examples": []
      },
      {
        "name": "rpcUrl",
        "type": "string",
        "typeKind": "string",
        "description": "Override RPC for the rent-exemption lookup.",
        "optional": true,
        "examples": []
      }
    ]
  },
  {
    "name": "getContractSnapshot",
    "description": "Fetch a contract and every account directly attached to it in one shot, then derive the contest minimum-bid floor at \"now\".\n\nStrategy: fetch `ConfigState` and `ContractState` in parallel, then read the contract's `activeRental` / `queuedRental` pointers and fetch whichever ones exist (in parallel). Pointers that equal SystemProgram are skipped without an RPC call. The bid floor is computed locally once all states are in.",
    "returnType": "ContractSnapshot",
    "group": "contract",
    "params": [
      {
        "name": "contractAddress",
        "type": "string | Address",
        "typeKind": "address",
        "description": "",
        "optional": false,
        "examples": []
      },
      {
        "name": "rpcUrl",
        "type": "string",
        "typeKind": "string",
        "description": "",
        "optional": true,
        "examples": []
      }
    ]
  },
  {
    "name": "tickBudget",
    "description": "Lamports burned by a given number of cron ticks at `PER_TICK_LAMPORTS` each. Useful for sizing a custom `executionBudget` before calling `estimateOwnerSetupCost`.",
    "returnType": "bigint",
    "group": "other",
    "params": []
  },
  {
    "name": "estimateRentalCost",
    "description": "Quote the ATLAS cost a borrower will pay for a given rate + duration. Pure helper — does not build a transaction. Lean fetch surface: config + contract + Clock sysvar (no rental accounts). For UIs that also need reservation/bid context, call `getContractSnapshot` once and derive both quote and bid floor from the same snapshot.\n\nApplies stale-discount decay before quoting so the escrow figure matches what `rental_accept` will write back if called at this cluster's current `Clock::unix_timestamp`.",
    "returnType": "RentalCostQuote",
    "group": "rental",
    "params": [
      {
        "name": "contract",
        "type": "string | Address",
        "typeKind": "address",
        "description": "Contract PDA address.",
        "optional": false,
        "examples": []
      },
      {
        "name": "durationSeconds",
        "type": "number | bigint",
        "typeKind": "unknown",
        "description": "Rental duration in seconds.",
        "optional": false,
        "examples": []
      },
      {
        "name": "bidStardust",
        "type": "bigint",
        "typeKind": "unknown",
        "description": "Optional ATLAS bid for reservations (Stardust units).",
        "optional": true,
        "examples": []
      },
      {
        "name": "rpcUrl",
        "type": "string",
        "typeKind": "string",
        "description": "Override RPC.",
        "optional": true,
        "examples": []
      }
    ]
  }
];

export const QUERIES_BY_NAME: Record<string, Query> = Object.fromEntries(
  QUERIES.map((q) => [q.name, q])
);
